export const common = {
  // Navigation
  'nav.features': 'Funktionen',
  'nav.howItWorks': 'Wie es funktioniert',
  'nav.pricing': 'Preise',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Über uns',
  'nav.getStarted': 'Loslegen',

  // About Us Section
  'aboutUs.badge': 'Über uns',
  'aboutUs.title': 'Über uns',
  'aboutUs.line1': 'Ideen sind billig.',
  'aboutUs.line2': 'Kapital nicht. Zeit schon gar nicht.',
  'aboutUs.paragraph1': 'IdeaOracle.ai wurde gegründet, weil die meisten Geschäfts\u00ADideen nicht an Mut scheitern – sondern an fehlender Ehrlichkeit. Zu viel Bestätigung. Zu wenig Realität.',
  'aboutUs.belief1a': 'Wir glauben nicht an Hype.',
  'aboutUs.belief1b': 'Wir glauben an Marktlogik.',
  'aboutUs.belief2a': 'Wir glauben nicht an Motivation.',
  'aboutUs.belief2b': 'Wir glauben an Nachfrage, Wettbewerb und Differenzierung.',
  'aboutUs.mission1': 'Unsere Aufgabe ist nicht, Ideen gut aussehen zu lassen.',
  'aboutUs.mission2': 'Unsere Aufgabe ist es, ihre Tragfähigkeit offenzulegen.',
  'aboutUs.analysis': 'IdeaOracle.ai analysiert Geschäfts-Nischen auf strukturelle Marktmechanik, realistische Nachfrage, Wettbewerbsintensität und Umsetzbarkeit. Nicht emotional. Nicht optimistisch. Sondern nüchtern.',
  'aboutUs.failure1': 'Die meisten Ideen scheitern.',
  'aboutUs.failure2': 'Nicht, weil Gründer unfähig sind –',
  'aboutUs.failure3': 'sondern weil niemand vorher klar genug war.',
  'aboutUs.clarity': 'Wir existieren, um diese Klarheit zu liefern.',
  'aboutUs.value1': 'Unbequem.',
  'aboutUs.value2': 'Direkt.',
  'aboutUs.value3': 'Konsequent.',
  'aboutUs.confirm': 'Wenn eine Idee Substanz hat, bestätigen wir sie.',
  'aboutUs.deny': 'Wenn nicht, sagen wir es ebenfalls.',
  'aboutUs.noApplause': 'Ohne Applaus.',
  'aboutUs.noSugarcoating': 'Ohne Schönreden.',
  'aboutUs.noTheater': 'Ohne Theater.',

  // Hero Section
  'hero.badge': 'Entscheidungs-KI für Geschäfts-Nischen',
  'hero.title1': 'Ideen sind billig.',
  'hero.title2': 'Fehlentscheidungen nicht.',
  'hero.subtitle': 'Eine KI, die deine Geschäfts-Nische bewertet,',
  'hero.subtitleLine2': 'bevor du investierst.',
  'hero.cta': 'Idee prüfen',
  'hero.ctaSecondary': 'Wie es funktioniert',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Credits pro Anfrage',
  'hero.stat2Value': 'Ab 7',
  'hero.stat2Label': 'Bewertungsstufen',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Ehrlich & Privat',
  'hero.trialTitle': 'Starte deine kostenlose Testphase',
  'hero.creditsLabel': 'Credits',
  'hero.trialTagline': 'Teste unseren KI-Assistenten 3 Tage kostenlos',
  'hero.trialCta': 'Registrieren & 250 Credits erhalten',
  'hero.trialNoCard': 'Keine Kreditkarte nötig. Keine Verpflichtung.',
  'admin.dashboard.tabs.plans': 'Pläne',

  // Features Section
  'features.title1': 'Leistungsstarke Funktionen für',
  'features.title2': 'moderne',
  'features.title3': 'Unternehmen',
  'features.honestVerdict.title': 'Ehrliche Bewertung statt Hype-Score',
  'features.honestVerdict.description': 'Klare gut/mittel/schwach-Verdicte mit echten Marktdaten und Wettbewerber-Recherche. Keine 9/10-Bewertungen, die jeder Idee schmeicheln.',
  'features.fullJourney.title': 'Vom Idee-Check zum Builder Report',
  'features.fullJourney.description': 'Validiere im Chat, vertiefe die Marktanalyse, exportiere einen 25–75-seitigen Builder Report mit Personas, Finanzplan, Go-to-Market und Pitch Deck.',
  'features.multilingual.title': '21 Sprachen, lokalisierte Marktdaten',
  'features.multilingual.description': 'Vom Schweizer KMU bis zum Solo-Founder in São Paulo — die KI antwortet in deiner Sprache, mit Quellen aus deinem Markt.',

  // How It Works
  'howItWorks.title': 'Wie es funktioniert',
  'howItWorks.subtitle': 'Vier Schritte zur Klarheit über deine Geschäfts-Nische.',
  'howItWorks.step1Title': 'Paket wählen',
  'howItWorks.step1Desc': 'Starter, Pro oder Builder – je nach Tiefe deiner Prüfung.',
  'howItWorks.step2Title': 'KI befragen',
  'howItWorks.step2Desc': 'Stelle deine Fragen zur Nische. Jede Anfrage kostet 30 Credits.',
  'howItWorks.step3Title': 'Ehrliches Urteil erhalten',
  'howItWorks.step3Desc': 'Die KI bewertet: Gut, Mittel oder Schlecht. Ohne Schönreden.',
  'howItWorks.step4Title': 'Entscheidung treffen',
  'howItWorks.step4Desc': 'Du weißt jetzt, ob es sich lohnt weiterzugehen.',

  // Pricing
  'pricing.title': 'Preise',
  'pricing.subtitle': 'Wähle das Paket, das zu deiner Prüftiefe passt.',
  'pricing.monthly': 'Monatlich',
  'pricing.yearly': 'Jährlich',
  'pricing.yearlyDiscount': 'Jahresabo:',
  'pricing.yearlyDiscountValue': '-20% Rabatt',
  'pricing.perMonth': 'pro Monat',
  'pricing.billedYearly': 'Jährlich abgerechnet',
  'pricing.savings': 'Ersparnis',
  'pricing.selectPlan': 'Paket wählen',
  'pricing.mostPopular': 'Beliebtestes',
  'pricing.footer': 'Alle Preise in CHF. Credits werden nur bei erfolgreichen KI-Antworten abgezogen.',
  
  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3 Tage kostenloser Zugang',
  'pricing.trial.credits': '250 Credits',
  'pricing.trial.free': 'Kostenlos',
  'pricing.trial.duration': '3 Tage kostenlos',
  'pricing.trial.cta': 'Kostenlos testen',
  'pricing.trial.feature1': '250 Credits zum Ausprobieren',
  'pricing.trial.feature2': 'Voller Zugriff für 3 Tage',
  'pricing.trial.feature3': 'Keine Kreditkarte erforderlich',
  'pricing.trial.feature4': 'Jederzeit kündbar',

  // Gold Paket
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10.000 Credits + 25-Seiten Builder Report',
  'pricing.gold.credits': '10.000 Credits',
  'pricing.gold.feature1': '10.000 Credits',
  'pricing.gold.feature2': '25 Seiten Builder Report',
  'pricing.gold.feature3': 'Alle Starter- und Pro-Funktionen',
  'pricing.gold.feature4': 'Marktanalyse & Zusammenfassung',
  'pricing.gold.feature5': 'Chancen, Risiken, Empfehlungen',
  'pricing.gold.feature6': 'PDF Herunterladen',
  'pricing.gold.feature7': 'Support',

  // Platinum Paket
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15.000 Credits + 75-Seiten Builder Report',
  'pricing.platinum.credits': '15.000 Credits',
  'pricing.platinum.feature1': '15.000 Credits',
  'pricing.platinum.feature2': '75 Seiten Builder Report',
  'pricing.platinum.feature3': 'Alle Gold-Funktionen',
  'pricing.platinum.feature4': 'Builder-Modus: Entwickler-Briefings',
  'pricing.platinum.feature5': 'Strukturierte Zusammenfassung',
  'pricing.platinum.feature6': 'Erweiterte Marktanalyse',
  'pricing.platinum.feature7': 'Support',

  // Chat-Modus / Geschwindigkeit
  'chat.tier.fast': 'Fast',
  'chat.tier.standard': 'Standard',
  'chat.tier.thinking': 'Thinking',
  'chat.askPrompt': 'Geben Sie Ihre Frage ein...',
  'chat.costsLabel': 'kostet',

  // Persistente Aktionsleiste (über dem Chat-Input, nur wenn eine Idee geladen ist)
  'chat.actionsHint': 'Wenn du bereit bist zu bauen',
  'chat.tray.builderReport': 'Builder Report · {{credits}} Cr',
  'chat.tray.devBriefing': 'Entwickler-Briefing · {{credits}} Cr',

  // Entwickler-Briefing (nur Builder / Platinum)
  'chat.devBriefing.cta': 'Entwickler-Briefing · {{credits}} Credits',
  'chat.devBriefing.locked': 'Entwickler-Briefing — {{plans}}-Plan nötig',
  'chat.devBriefing.generating': 'Entwickler-Briefing wird erstellt…',
  'chat.devBriefing.needIdea': 'Analysiere zuerst eine Idee, dann kann ich ein Entwickler-Briefing erstellen.',
  'chat.devBriefing.planGate': 'Das Entwickler-Briefing ist eine Funktion des Builder- / Platinum-Plans.',
  'chat.devBriefing.failed': 'Entwickler-Briefing fehlgeschlagen.',

  // Top-up
  'dashboard.credits.topup.button': 'Credits nachkaufen',
  'dashboard.credits.topup.buttonTitle': 'Credits nachkaufen, ohne den Plan zu wechseln',
  'dashboard.credits.topup.title': 'Credits nachkaufen',
  'dashboard.credits.topup.subtitle': 'CHF 0.15 pro Credit — kein Plan-Wechsel nötig',
  'dashboard.credits.topup.quickAmounts': 'Schnellauswahl',
  'dashboard.credits.topup.custom': 'Benutzerdefiniert',
  'dashboard.credits.topup.totalLabel': 'Gesamt',
  'dashboard.credits.topup.creditsLabel': 'Credits',
  'dashboard.credits.topup.confirm': 'Jetzt kaufen',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Zugriff auf den KI-Nischen-Chatbot',
  'pricing.starter.credits': '2\'500 Credits pro Monat',
  'pricing.starter.feature1': 'Freier Chat (kein Formular)',
  'pricing.starter.feature2': 'Marktlogik & ehrliche Bewertung',
  'pricing.starter.feature3': 'Persistenter Chat-Verlauf',
  'pricing.starter.feature4': 'Mehrere parallele Chat-Sessions',
  'pricing.starter.feature5': 'Vollständig mehrsprachig',
  'pricing.starter.feature6': 'Credit-basierte Nutzung',
  'pricing.starter.feature7': 'Monatlicher Reset',
  'pricing.starter.feature8': 'Keine Entwickler-Briefings',
  'pricing.starter.feature9': 'Marktanalyse',
  'pricing.starter.feature10': 'Zusammenfassung',
  'pricing.starter.feature11': 'Stärken',
  'pricing.starter.feature12': 'Schwächen',
  'pricing.starter.feature13': 'Chancen',
  'pricing.starter.feature14': 'Risiken',
  'pricing.starter.feature15': 'Empfehlungen',
  'pricing.starter.feature16': 'PDF Herunterladen',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Zugriff auf den KI-Nischen-Chatbot',
  'pricing.pro.credits': '5\'000 Credits pro Monat',
  'pricing.pro.feature1': 'Freier Chat (kein Formular)',
  'pricing.pro.feature2': 'Marktlogik & ehrliche Bewertung',
  'pricing.pro.feature3': 'Persistenter Chat-Verlauf',
  'pricing.pro.feature4': 'Mehrere parallele Chat-Sessions',
  'pricing.pro.feature5': 'Vollständig mehrsprachig',
  'pricing.pro.feature6': 'Credit-basierte Nutzung',
  'pricing.pro.feature7': 'Monatlicher Reset',
  'pricing.pro.feature8': 'Keine Entwickler-Briefings',
  'pricing.pro.feature9': 'Marktanalyse',
  'pricing.pro.feature10': 'Zusammenfassung',
  'pricing.pro.feature11': 'Stärken',
  'pricing.pro.feature12': 'Schwächen',
  'pricing.pro.feature13': 'Chancen',
  'pricing.pro.feature14': 'Risiken',
  'pricing.pro.feature15': 'Empfehlungen',
  'pricing.pro.feature16': 'PDF Herunterladen',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.price': '199',
  'pricing.builder.description': 'Alle Funktionen + Builder-Modus',
  'pricing.builder.credits': 'Unlimited Credits',
  'pricing.builder.feature1': 'Freier Chat (kein Formular)',
  'pricing.builder.feature2': 'Marktlogik & ehrliche Bewertung',
  'pricing.builder.feature3': 'Persistenter Chat-Verlauf',
  'pricing.builder.feature4': 'Mehrere parallele Chat-Sessions',
  'pricing.builder.feature5': 'Vollständig mehrsprachig',
  'pricing.builder.feature6': 'Builder-Modus: Entwickler-Briefings',
  'pricing.builder.feature7': 'Strukturierte Zusammenfassung',
  'pricing.builder.feature9': 'Marktanalyse',
  'pricing.builder.feature10': 'Zusammenfassung',
  'pricing.builder.feature11': 'Stärken',
  'pricing.builder.feature12': 'Schwächen',
  'pricing.builder.feature13': 'Chancen',
  'pricing.builder.feature14': 'Risiken',
  'pricing.builder.feature15': 'Empfehlungen',
  'pricing.builder.feature16': 'PDF Herunterladen',
  'pricing.monthlyReset': 'Monatlicher Reset',

  // Modal
  'pricing.modal.selected': 'ausgewählt',
  'pricing.modal.comingSoon': 'Die Registrierung und Zahlungsabwicklung wird in Kürze verfügbar sein.',
  'pricing.modal.patience': 'Wir arbeiten daran, dir ein sicheres und nahtloses Erlebnis zu bieten. Bitte habe noch etwas Geduld.',
  'pricing.modal.understood': 'Verstanden',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Ehrlich & kritisch beantwortet.',
  'faq.q1': 'Was macht IdeaOracle.ai konkret?',
  'faq.a1': 'IdeaOracle.ai prüft Geschäfts\u00ADideen und Nischen auf Marktlogik, reale Nachfrage, Wettbewerb, Differenzierung und Umsetzbarkeit.\nWenn Substanz vorhanden ist, zeigen wir, wie sie strategisch geschärft werden kann.\nWenn nicht, sagen wir es.',
  'faq.q2': 'Generiert ihr auch Ideen?',
  'faq.a2': 'Ja.\nAber nicht blind.\nWir entwickeln Ansätze unter Marktlogik – nicht aus Motivation oder Trend-Hype.',
  'faq.q3': 'Optimiert ihr Geschäftsmodelle?',
  'faq.a3': 'Ja – sofern Potenzial vorhanden ist.\nWir polieren keine Illusionen.\nWir machen tragfähige Konzepte belastbarer.',
  'faq.q4': 'Was unterscheidet euch von anderen KI-Tools?',
  'faq.a4': 'Andere Tools liefern Inspiration.\nWir liefern Einschätzung.\nDer Fokus liegt auf Realismus, nicht auf Begeisterung.',
  'faq.q5': 'Ist das eine Garantie für Erfolg?',
  'faq.a5': 'Nein.\nWir reduzieren Fehlentscheidungen – wir eliminieren kein Risiko.',
  'faq.q6': 'Für wen ist IdeaOracle.ai geeignet?',
  'faq.a6': 'Gründer vor dem Start\nUnternehmer vor Expansion\nSide-Builder vor Zeitinvest\nInvestoren vor Prüfung\n\nKurz: Für Menschen, die Klarheit vor Kapital wollen.',
  'faq.q7': 'Was, wenn ich nur Bestätigung suche?',
  'faq.a7': 'Dann ist IdeaOracle.ai nicht das richtige Tool.',
  'faq.q8': 'Wie ehrlich ist die Analyse?',
  'faq.a8': 'So ehrlich, wie es Daten und Marktmechanik erlauben.\nKeine Euphorie. Keine Schonung.',
  'faq.q9': 'Ersetzt ihr Marktforschung?',
  'faq.a9': 'Nein.\nWir sind eine strategische Vorausprüfung – keine vollständige Marktstudie.',
  'faq.q10': 'Warum so kompromisslos?',
  'faq.a10': 'Weil Scheitern teuer ist.\nEhrlichkeit nicht.',

  // Footer
  'footer.description': 'Diese Plattform hilft dir nicht, dich gut zu fühlen – sondern richtig zu entscheiden.',
  'footer.product': 'Produkt',
  'footer.aiAssistant': 'KI-Assistent',
  'footer.howItWorks': 'Wie es funktioniert',
  'footer.pricing': 'Preise',
  'footer.faq': 'FAQ',
  'footer.legal': 'Rechtliches',
  'footer.privacy': 'Datenschutz',
  'footer.terms': 'AGB',
  'footer.imprint': 'Impressum',
  'footer.support': 'Support',
  'footer.contact': 'Kontakt',
  'footer.documentation': 'Dokumentation',
  'footer.copyright': '© 2025 IdeaOracle.ai. Alle Rechte vorbehalten.',

  // AI Assistant
  'aiAssistant.title': 'KI-Nischen-Assistent',
  'aiAssistant.subtitle': 'Fragen zu Nischen',
  'aiAssistant.welcomeMessage': 'Hi! Beschreibe deine Idee oder frage mich nach einer Nische. Ich gebe dir eine klare und ehrliche Bewertung.',
  'aiAssistant.demoResponse': 'Dies ist eine Demo-Antwort. Um deine Ideen professionell bewerten zu lassen, registriere dich bitte und wähle ein Paket.',
  'aiAssistant.placeholder': 'Beschreibe deine Idee...',
  'aiAssistant.suggestionsLabel': 'Probiere eine dieser Fragen',
  'aiAssistant.fallback':
    'Darauf habe ich keine direkte Antwort — aber ein Mensch schon. Schreib an support@ideaoracle.ai, wir melden uns schnell zurück.',

  // 21-Intent-FAQ — beantwortet vom "Sprich mit uns"-Widget ohne KI-Credits.
  'aiAssistant.faq.what_is.q': 'Was ist IdeaOracle.ai?',
  'aiAssistant.faq.what_is.a':
    'IdeaOracle.ai ist eine Entscheidungs-KI für Geschäftsideen. Du beschreibst eine Idee oder Nische — wir bewerten Marktlogik, reale Nachfrage, Wettbewerb und Tragfähigkeit, ohne Beschönigung. Gut, mittel oder schlecht — wir sagen es direkt.',
  'aiAssistant.faq.how_it_works.q': 'Wie funktioniert das?',
  'aiAssistant.faq.how_it_works.a':
    'Vier Schritte: 1) Plan wählen (oder kostenlose Testphase starten), 2) KI-Assistent öffnen und Idee beschreiben, 3) Bewertung (Gut / Mittel / Schlecht) plus Marktanalyse, Wettbewerb, Stärken, Schwächen, Risiken, Chancen und Empfehlungen erhalten, 4) weiterentwickeln oder einen vollständigen Builder Report (PDF) generieren, wenn du die Idee wirklich umsetzen willst.',
  'aiAssistant.faq.pricing.q': 'Was kostet das?',
  'aiAssistant.faq.pricing.a':
    'Pläne (CHF / Monat): Trial kostenlos · Starter 39,90 · Pro 59,90 · Builder 199 · Gold 199 · Platinum 399. Jährliche Abrechnung mit 20 % Rabatt auf jeden bezahlten Plan. Vollständige Übersicht im Pricing-Bereich der Homepage.',
  'aiAssistant.faq.plans.q': 'Welche Pläne gibt es?',
  'aiAssistant.faq.plans.a':
    '6 Pläne: Trial (250 Credits, 3 Tage, kostenlos), Starter (2.500 Credits / 39,90 CHF), Pro (5.000 / 59,90), Builder (10.000 / 199 — mit Entwickler-Briefings + 25-Seiten Builder Report), Gold (12.500 / 199 — 50-Seiten Report), Platinum (15.000 / 399 — 75-Seiten Report, Premium-Support).',
  'aiAssistant.faq.trial.q': 'Gibt es eine kostenlose Testphase?',
  'aiAssistant.faq.trial.a':
    'Ja — 3 Tage kostenlos mit 250 Credits. Keine Kreditkarte erforderlich. Jederzeit kündbar oder direkt aus dem Dashboard upgraden.',
  'aiAssistant.faq.credits.q': 'Was ist ein Credit?',
  'aiAssistant.faq.credits.a':
    'Ein Credit ist die Einheit der KI-Nutzung — jede Analyse, jede Chat-Nachricht und jeder Report kostet Credits. Jeder Plan enthält ein monatliches Credit-Paket, das jede Abrechnungsperiode zurückgesetzt wird; ungenutzte Credits werden nicht übertragen.',
  'aiAssistant.faq.credits_cost.q': 'Wie viele Credits kostet eine Analyse?',
  'aiAssistant.faq.credits_cost.a':
    'Pro Chat-Nachricht: Fast 30 Credits, Standard 50, Thinking 100. Eine vollständige Ideenanalyse läuft in denselben Stufen. Der Builder Report und das Entwickler-Briefing sind separat (Credit-Kosten pro Workspace konfigurierbar).',
  'aiAssistant.faq.run_out_credits.q': 'Was passiert, wenn meine Credits aufgebraucht sind?',
  'aiAssistant.faq.run_out_credits.a':
    'Du kannst auf den monatlichen Reset warten, deinen Plan upgraden oder einmalig Credits nachkaufen — direkt im Credits-Bereich deines Dashboards, ohne Plan-Wechsel.',
  'aiAssistant.faq.topup.q': 'Kann ich zusätzliche Credits kaufen, ohne zu upgraden?',
  'aiAssistant.faq.topup.a':
    'Ja. Dashboard → Credits → „Credits nachkaufen". Preis: CHF 0,15 pro Credit, Minimum 100 Credits (CHF 15), Maximum 50.000 (CHF 7.500). Die Credits landen sofort auf deinem Konto.',
  'aiAssistant.faq.builder_report.q': 'Was ist der Builder Report?',
  'aiAssistant.faq.builder_report.a':
    'Eine strategische PDF-Tiefenanalyse mit detaillierten Personas, Finanzmodell, Unit Economics, Go-to-Market-Plan, Moat-Analyse und Pitch-Deck-Gliederung. Seitenzahl skaliert mit dem Plan: Builder 25 · Gold 50 · Platinum 75. In wenigen Minuten aus jeder gespeicherten Idee generiert.',
  'aiAssistant.faq.dev_briefing.q': 'Was ist das Entwickler-Briefing?',
  'aiAssistant.faq.dev_briefing.a':
    'Eine strukturierte 9-Abschnitts-Produkt-/Engineering-Spezifikation — das Dokument, das du einem Entwickler oder einer Agentur zur Umsetzung gibst. Enthält: was gebaut werden soll, User-Flow, Screens, Backend, Datenbank, Architektur, MVP-Plan und eine Beispiel-Ordnerstruktur. Verfügbar in den Plänen Builder und Platinum.',
  'aiAssistant.faq.privacy.q': 'Sind meine Daten sicher?',
  'aiAssistant.faq.privacy.a':
    'Ja. Deine Ideen sind ausschließlich deinem Konto zugeordnet. Wir verkaufen keine Daten, trainieren keine öffentlichen Modelle damit und teilen nichts mit Dritten. Details in unserer Datenschutzerklärung.',
  'aiAssistant.faq.languages.q': 'Welche Sprachen werden unterstützt?',
  'aiAssistant.faq.languages.a':
    '21 Sprachen für UI und KI-Antworten — unter anderem Deutsch, Englisch, Französisch, Spanisch, Italienisch, Niederländisch, Portugiesisch, Polnisch, Türkisch, Russisch, Japanisch, Koreanisch, Chinesisch, Hindi, Arabisch u. a. Jederzeit über den Sprachselektor umschaltbar.',
  'aiAssistant.faq.cancel.q': 'Wie kann ich mein Abonnement kündigen?',
  'aiAssistant.faq.cancel.a':
    'Dashboard → Abonnement → Kündigen. Du behältst vollen Zugriff bis zum Ende der laufenden Abrechnungsperiode. Keine Halte-Schleifen, keine Telefonanrufe.',
  'aiAssistant.faq.refund.q': 'Gibt es eine kostenlose Testphase?',
  'aiAssistant.faq.refund.a':
    'Ja — registriere dich und nutze die Test-Credits, um die Plattform vor dem Upgrade kostenlos auszuprobieren. Auf bezahlte Pläne gibt es keine Geld-zurück-Garantie, daher empfehlen wir, zuerst die Testphase zu nutzen. Für Ausnahmefälle schreib an support@ideaoracle.ai — wir prüfen das individuell.',
  'aiAssistant.faq.support.q': 'Wie erreiche ich den Support?',
  'aiAssistant.faq.support.a':
    'Schreib an support@ideaoracle.ai — wir antworten innerhalb eines Arbeitstages. Für alles, was unser FAQ-Bot beantworten kann, chatte einfach hier weiter.',
  'aiAssistant.faq.mobile.q': 'Gibt es eine Mobile-App?',
  'aiAssistant.faq.mobile.a':
    'Noch nicht. Die Web-App ist vollständig responsiv und funktioniert gut auf Smartphones und Tablets. Eine native Mobile-App steht auf der Roadmap, aber noch ohne Release-Datum.',
  'aiAssistant.faq.multiple_ideas.q': 'Kann ich mehrere Ideen analysieren?',
  'aiAssistant.faq.multiple_ideas.a':
    'Ja — jede Analyse wird in deinem Verlauf gespeichert. Du kannst mehrere parallele Chat-Sessions öffnen, zwischen früheren Ideen wechseln, als PDF, TXT oder JSON exportieren oder auf Wunsch in eine andere Sprache übersetzen.',
  'aiAssistant.faq.payment.q': 'Welche Zahlungsmethoden werden akzeptiert?',
  'aiAssistant.faq.payment.a':
    'Alle gängigen Kreditkarten über Stripe. Rechnung für Jahres- / Enterprise-Pläne auf Anfrage — schreib an support@ideaoracle.ai.',
  'aiAssistant.faq.who_for.q': 'Für wen ist IdeaOracle?',
  'aiAssistant.faq.who_for.a':
    'Für Gründer vor dem Start, Unternehmer vor der Expansion, Side-Builder vor dem Zeitinvestment und Investoren vor dem Check. Für alle, die Klarheit vor Kapital wollen.',
  'aiAssistant.faq.honesty.q': 'Wie ehrlich ist die KI?',
  'aiAssistant.faq.honesty.a':
    'Brutal ehrlich. Wir bestätigen nicht, um zu bestätigen — wenn eine Idee schwach ist, sagen wir das mit Begründung. Gute Ideen werden geschärft, schlechte schnell verworfen. Es geht darum, dir Zeit und Geld zu sparen, nicht Gefühle.',

  // Header & Sidebar
  'dashboard.header.title': 'Dashboard',
  'dashboard.header.tagline': 'Ihr KI-Assistent',
  'dashboard.header.logout': 'Abmelden',
  'dashboard.quickActions.creditsCost': '{{count}} Credits',
  'chat.builderOfferMessage': 'Möchtest du daraus einen vollständigen Builder Report machen — eine strategische Tiefenanalyse mit detaillierten Personas, Finanzmodell, Go-to-Market-Plan, Moat-Analyse und Pitch-Deck-Gliederung? Seitenzahl skaliert mit deinem Plan: Builder 25 Seiten, Gold 50 Seiten, Platinum 75 Seiten. Aktuelle Credit-Kosten siehe Button unten.',
  'chat.builderOfferTitle': 'Bereit zum Bauen? Generiere den vollständigen Builder Report',
  'chat.builderOfferCta': 'Builder Report generieren · 200 Credits',
  'chat.builderOfferCtaDynamic': 'Builder Report generieren · {{credits}} Credits',
  'chat.builderOfferLocked': 'Builder Report — {{plans}} Tarif erforderlich',
  'chat.builderOfferUpgrade': 'Upgrade auf {{plans}} zum Entsperren',
  'chat.builderOfferHint': 'oder schreib "Builder Report erstellen", dann startet die KI ihn für dich',
  'dashboard.sidebar.overview': 'Übersicht',
  'dashboard.sidebar.dashboard': 'Dashboard',
  'dashboard.sidebar.aiAssistant': 'KI-Assistent',
  'dashboard.sidebar.newAnalysis': 'KI-Assistent',
  'dashboard.sidebar.history': 'Verlauf',
  'dashboard.sidebar.credits': 'Credits',
  'dashboard.sidebar.subscription': 'Abo & Zahlung',
  'dashboard.sidebar.settings': 'Einstellungen',
  'dashboard.sidebar.plan': 'Plan',

  // Shared dashboard labels
  'dashboard.unlimited': 'Unbegrenzt',
  'dashboard.upgrade': 'Upgrade',
  'dashboard.close': 'Schliessen',
  'dashboard.backToOverview': 'Zurück zur Übersicht',

  // Dashboard Overview (full page)
  'dashboard.overview.title': 'Übersicht',
  'dashboard.overview.last24Hours': 'Letzte 24 Stunden',
  'dashboard.overview.loadError': 'Übersicht konnte nicht geladen werden',
  'dashboard.overview.plan': 'Plan',
  'dashboard.overview.unlimitedCredits': 'Unbegrenzte Credits verfügbar',
  'dashboard.overview.creditsAvailable': '{{formatted}} Credits verfügbar',
  'dashboard.overview.creditsUsageThisMonth': 'Credit-Verbrauch diesen Monat',
  'dashboard.overview.creditsAvailablePct': '{{pct}}% verfügbar',
  'dashboard.overview.recentActivity': 'Letzte Aktivitäten',
  'dashboard.overview.noActivity': 'Noch keine Aktivitäten',
  'dashboard.overview.latestIdeas': 'Neueste Ideen',
  'dashboard.overview.noIdeas': 'Noch keine Ideen analysiert',
  'dashboard.overview.viewAll': 'Alle anzeigen',
  'dashboard.overview.upgradePlan': 'Plan upgraden',
  'dashboard.overview.buyCredits': 'Credits kaufen',
  'dashboard.overview.quickAccess': 'Schnellzugriff',
  'dashboard.overview.quickAccessItems.startAnalysis': 'Neue Analyse starten',
  'dashboard.overview.quickAccessItems.startAnalysisDesc': 'Starte eine neue KI-gestützte Nischen-Analyse',
  'dashboard.overview.quickAccessItems.myAnalyses': 'Meine Analysen',
  'dashboard.overview.quickAccessItems.myAnalysesDesc': 'Alle bisherigen Analysen ansehen',
  'dashboard.overview.quickAccessItems.buyCredits': 'Credits kaufen',
  'dashboard.overview.quickAccessItems.buyCreditsDesc': 'Mehr Credits für mehr Analysen',
  'dashboard.overview.quickAccessItems.settings': 'Einstellungen',
  'dashboard.overview.quickAccessItems.settingsDesc': 'Profil und Präferenzen anpassen',
  'dashboard.overview.stats.analysesToday': 'Analysen heute',
  'dashboard.overview.stats.analysesTotal': 'Analysen gesamt',
  'dashboard.overview.stats.successRate': 'Erfolgsrate',
  'dashboard.overview.stats.topRatings': 'Top-Bewertungen',
  'dashboard.overview.activity.nicheAnalysisComplete': 'Nischen-Analyse abgeschlossen',
  'dashboard.overview.activity.refund': 'Rückerstattung',
  'dashboard.overview.activity.payment': 'Zahlung',
  'dashboard.overview.time.justNow': 'gerade eben',
  'dashboard.overview.time.minutesAgo': 'vor {{count}} Min.',
  'dashboard.overview.time.hoursAgo': 'vor {{count}} Std.',
  'dashboard.overview.time.daysAgo_one': 'vor {{count}} Tag',
  'dashboard.overview.time.daysAgo_other': 'vor {{count}} Tagen',
  'dashboard.overview.time.daysAgo': 'vor {{count}} Tagen',

  // Chat additions
  'chat.ratingStrong': 'Stark',
  'chat.ratingMixed': 'Gemischt',
  'chat.ratingWeak': 'Schwach',
  'chat.loadIdeaError': 'Idee konnte nicht geladen werden',
  'chat.deleteError': 'Löschen fehlgeschlagen',
  'chat.notEnoughCreditsTitle': 'Nicht genug Credits',
  'chat.currentBalance': 'Ihr aktuelles Guthaben:',
  'chat.ai': 'KI',
  'chat.you': 'Sie',

  // Chat — Spracherkennung
  'chat.speechNotSupported': 'Spracherkennung wird von Ihrem Browser nicht unterstützt.',
  'chat.microphonePermissionDenied': 'Mikrofonzugriff wurde verweigert.',
  'chat.listeningPlaceholder': 'Ich höre zu… Sprechen Sie jetzt.',
  'chat.stopListening': 'Aufnahme stoppen',
  'chat.recording': 'Aufnahme läuft…',

  // Chat — Sitzungs-Aktionen & Toasts
  'chat.renameSuccess': 'Name aktualisiert (nur lokal)',
  'chat.deleted': 'Chat gelöscht',

  // Chat — Export
  'chat.export': 'Exportieren',
  'chat.exportAll': 'Exportieren',
  'chat.exportSuccess': 'Export erfolgreich!',
  'chat.allExportSuccess': 'Alle Chats exportiert!',
  'chat.noSessionsToExport': 'Keine Chats zum Exportieren',
  'chat.allChats': 'Alle Chat-Verläufe',
  'chat.exportedOn': 'Exportiert am',
  'chat.totalChats': 'Anzahl Chats',
  'chat.chat': 'Chat',
  'chat.createdAt': 'Erstellt',
  'chat.updatedAt': 'Aktualisiert',

  // Chat — KI schreibt & Credit-Banner
  'chat.aiTyping': 'KI schreibt…',
  'chat.noCreditsTitle': 'Keine Credits mehr',
  'chat.noCreditsDesc': 'Bitte upgraden Sie Ihr Paket.',
  'chat.lowCreditsTitle': 'Credits werden knapp',
  'chat.lowCreditsDesc_one': 'Noch {{count}} Credit übrig.',
  'chat.lowCreditsDesc_other': 'Noch {{count}} Credits übrig.',
  'chat.lowCreditsDesc': 'Noch {{count}} Credits übrig.',

  // Chat — Seitenleiste Zähler
  'chat.messagesCount_one': '{{count}} Nachricht',
  'chat.messagesCount_other': '{{count}} Nachrichten',
  'chat.messagesCount': '{{count}} Nachrichten',

  // Rating (additional)
  'rating.unknown': 'Unbekannt',

  // Credit Usage
  'dashboard.credits.title': 'Credit-Verbrauch',
  'dashboard.credits.subtitle': 'Ihr aktueller Verbrauch',
  'dashboard.credits.loadError': 'Credits konnten nicht geladen werden',
  'dashboard.credits.downgradePending': 'Downgrade wartet auf Genehmigung durch den Administrator.',
  'dashboard.credits.planUpdated': 'Plan erfolgreich aktualisiert!',
  'dashboard.credits.planChangeFailed': 'Planwechsel fehlgeschlagen',
  'dashboard.credits.planSuffix': 'Plan',
  'dashboard.credits.downgradeWaiting': 'Downgrade wartet auf Genehmigung',
  'dashboard.credits.used': 'Verbraucht',
  'dashboard.credits.resetOn': 'Reset am {{date}}',
  'dashboard.credits.recentActivity': 'Letzte Aktivitäten',
  'dashboard.credits.noActivity': 'Noch keine Aktivitäten',
  'dashboard.credits.currentPackage': 'Ihr aktuelles Paket',
  'dashboard.credits.chfPerMonth': 'CHF/Monat',
  'dashboard.credits.creditsPerMonth': '{{formatted}} Credits/Monat',
  'dashboard.credits.perMonth': 'pro Monat',
  'dashboard.credits.upgradePackage': 'Paket upgraden',
  'dashboard.credits.changePlan': 'Plan ändern',
  'dashboard.credits.current': 'Aktuell',
  'dashboard.credits.premium': 'Premium',
  'dashboard.credits.noPlans': 'Keine Pläne verfügbar.',
  'dashboard.credits.currentPlan': 'Aktueller Plan',
  'dashboard.credits.selected': 'Ausgewählt',
  'dashboard.credits.selectPlan': '{{plan}} auswählen',
  'dashboard.credits.processing': 'Wird verarbeitet...',
  'dashboard.credits.switchPlan': 'Plan wechseln',
  'dashboard.credits.tx.deduction': 'Credits verwendet',
  'dashboard.credits.tx.reset': 'Monatlicher Reset',
  'dashboard.credits.tx.bonus': 'Bonus-Credits',
  'dashboard.credits.tx.refund': 'Rückerstattung',

  // Idea History
  'dashboard.history.title': 'Ideen-Verlauf',
  'dashboard.history.loadError': 'Ideen konnten nicht geladen werden',
  'dashboard.history.analysesCount': '{{count}} Analysen',
  'dashboard.history.yourLatest': 'Ihre letzten Analysen',
  'dashboard.history.refresh': 'Aktualisieren',
  'dashboard.history.exportAll': 'Alle exportieren',
  'dashboard.history.searchPlaceholder': 'Ideen durchsuchen...',
  'dashboard.history.allRatings': 'Alle Bewertungen',
  'dashboard.history.emptyTitle': 'Noch keine Analysen',
  'dashboard.history.emptyDesc': 'Starten Sie einen Chat, um Ihre erste Geschäftsidee zu bewerten. Abgeschlossene Analysen erscheinen hier automatisch.',
  'dashboard.history.startFirstChat': 'Ersten Chat starten',
  'dashboard.history.noMatchTitle': 'Keine Treffer',
  'dashboard.history.noMatchDesc': 'Keine Analyse entspricht Ihrem Filter. Passen Sie Suche oder Bewertung an.',
  'dashboard.history.fullAnalysis': 'Vollständige Analyse',
  'dashboard.history.translating': 'Analyse wird in deine aktuelle Sprache übersetzt…',
  'dashboard.history.download': 'Herunterladen',
  'dashboard.history.saveAsJson': 'Als JSON speichern',
  'dashboard.history.saveAsTxt': 'Als TXT speichern',
  'dashboard.history.saveAsPdf': 'Als PDF speichern',
  'dashboard.history.deleteAnalysisTitle': 'Analyse löschen?',
  'dashboard.history.actionIrreversible': 'Diese Aktion kann nicht rückgängig gemacht werden.',
  'dashboard.history.deleteSuccess': 'Analyse erfolgreich gelöscht',
  'dashboard.history.deleteError': 'Löschen fehlgeschlagen',
  'dashboard.history.jsonSuccess': 'JSON-Datei erfolgreich heruntergeladen',
  'dashboard.history.txtSuccess': 'TXT-Datei erfolgreich heruntergeladen',
  'dashboard.history.pdfSuccess': 'PDF-Datei erfolgreich heruntergeladen',
  'dashboard.history.exportError': 'Fehler beim Exportieren',
  'dashboard.history.allExportedAsJson': '{{count}} Ideen als JSON exportiert',
  'dashboard.history.marketAnalysis': 'Marktanalyse',
  'dashboard.history.swotAnalysis': 'SWOT-Analyse',
  'dashboard.history.recommendations': 'Empfehlungen',
  'dashboard.history.actionRecommendations': 'Handlungsempfehlungen',
  'dashboard.history.export.header': 'IDEEN-ANALYSE EXPORT',
  'dashboard.history.export.title': 'Titel',
  'dashboard.history.export.rating': 'Bewertung',
  'dashboard.history.export.date': 'Datum',
  'dashboard.history.export.category': 'Kategorie',
  'dashboard.history.export.targetAudience': 'Zielgruppe',
  'dashboard.history.export.metrics': 'Kennzahlen',
  'dashboard.history.export.summary': 'Zusammenfassung',
  'dashboard.history.export.exportedOn': 'Exportiert am',
  'dashboard.history.pdf.header': 'Geschäftsideen-Analyse',
  'dashboard.history.metrics.marketSize': 'Marktgröße',
  'dashboard.history.metrics.competition': 'Wettbewerb',
  'dashboard.history.metrics.startupCost': 'Startkapital',
  'dashboard.history.metrics.timeToMarket': 'Zeit bis Markt',
  'dashboard.history.metrics.profitPotential': 'Gewinnpotenzial',
  'dashboard.history.metrics.scalability': 'Skalierbarkeit',
  'dashboard.history.swot.strengths': 'Stärken',
  'dashboard.history.swot.weaknesses': 'Schwächen',
  'dashboard.history.swot.opportunities': 'Chancen',
  'dashboard.history.swot.threats': 'Risiken',

  // Settings
  'dashboard.settings.title': 'Einstellungen',
  'dashboard.settings.subtitle': 'Verwalten Sie Ihr Konto und Ihre Präferenzen',
  'dashboard.settings.loadError': 'Einstellungen konnten nicht geladen werden',
  'dashboard.settings.profileSaved': 'Profil erfolgreich gespeichert',
  'dashboard.settings.preferencesSaved': 'Präferenzen erfolgreich gespeichert',
  'dashboard.settings.notificationsSaved': 'Benachrichtigungseinstellungen gespeichert',
  'dashboard.settings.saveFailed': 'Speichern fehlgeschlagen',
  'dashboard.settings.saving': 'Speichere...',
  'dashboard.settings.saveChanges': 'Änderungen speichern',
  'dashboard.settings.deleting': 'Lösche...',
  'dashboard.settings.deleteConfirmKeyword': 'LÖSCHEN',
  'dashboard.settings.deleteAccountFailed': 'Konto-Löschung fehlgeschlagen',
  'dashboard.settings.dataExportSuccess': 'Daten erfolgreich exportiert',
  'dashboard.settings.tabs.profile': 'Profil',
  'dashboard.settings.tabs.preferences': 'Präferenzen',
  'dashboard.settings.tabs.notifications': 'Benachrichtigungen',
  'dashboard.settings.tabs.account': 'Konto & Abo',
  'dashboard.settings.profile.name': 'Name',
  'dashboard.settings.profile.email': 'E-Mail',
  'dashboard.settings.profile.phone': 'Telefon',
  'dashboard.settings.profile.avatarNote': 'Profilbild via Update-URL konfigurierbar',
  'dashboard.settings.preferences.language': 'Sprache',
  'dashboard.settings.preferences.timezone': 'Zeitzone',
  'dashboard.settings.preferences.currency': 'Währung',
  'dashboard.settings.notifications.emailTitle': 'E-Mail-Benachrichtigungen',
  'dashboard.settings.notifications.pushTitle': 'Push-Benachrichtigungen',
  'dashboard.settings.notifications.emailAnalysis.title': 'Analyse abgeschlossen',
  'dashboard.settings.notifications.emailAnalysis.desc': 'Erhalten Sie eine E-Mail, wenn Ihre Analyse fertig ist',
  'dashboard.settings.notifications.emailCredits.title': 'Credit-Updates',
  'dashboard.settings.notifications.emailCredits.desc': 'Benachrichtigungen über Credits und Resets',
  'dashboard.settings.notifications.emailBilling.title': 'Rechnungen & Zahlungen',
  'dashboard.settings.notifications.emailBilling.desc': 'Benachrichtigungen über Rechnungen und Abo-Änderungen',
  'dashboard.settings.notifications.emailNewsletter.title': 'Newsletter',
  'dashboard.settings.notifications.emailNewsletter.desc': 'Tipps, Updates und neue Features',
  'dashboard.settings.notifications.pushAnalysis.title': 'Analyse abgeschlossen',
  'dashboard.settings.notifications.pushAnalysis.desc': 'Browser-Benachrichtigung bei fertiger Analyse',
  'dashboard.settings.notifications.pushCredits.title': 'Credit-Warnungen',
  'dashboard.settings.notifications.pushCredits.desc': 'Warnung bei niedrigem Credit-Stand',
  'dashboard.settings.account.currentPlan': 'Aktuelles Abo',
  'dashboard.settings.account.plan': 'Plan',
  'dashboard.settings.account.price': 'Preis',
  'dashboard.settings.account.moAbbrev': 'Mo',
  'dashboard.settings.account.nextBilling': 'Nächste Abrechnung',
  'dashboard.settings.account.manageSubscription': 'Abo & Zahlungen verwalten',
  'dashboard.settings.privacy.title': 'Daten & Privatsphäre',
  'dashboard.settings.privacy.exportData': 'Daten exportieren',
  'dashboard.settings.privacy.deleteAccount': 'Konto löschen',
  'dashboard.settings.deleteModal.title': 'Konto löschen?',
  'dashboard.settings.deleteModal.subtitle': 'Alle Daten werden unwiderruflich gelöscht.',
  'dashboard.settings.deleteModal.point1': 'Alle Analysen und Daten werden gelöscht',
  'dashboard.settings.deleteModal.point2': 'Aktives Abo wird sofort gekündigt',
  'dashboard.settings.deleteModal.point3': 'Keine Rückerstattung möglich',
  'dashboard.settings.deleteModal.typeKeyword': 'Geben Sie "{{keyword}}" ein *',

  // Subscription
  'dashboard.subscription.title': 'Abo & Zahlung',
  'dashboard.subscription.subtitle': 'Verwalten Sie Ihr Abonnement und Ihre Rechnungen',
  'dashboard.subscription.loadError': 'Abonnement konnte nicht geladen werden',
  'dashboard.subscription.cancelKeyword': 'KÜNDIGEN',
  'dashboard.subscription.cancelSuccess': 'Ihr Abo wurde zum Ende des Abrechnungszeitraums gekündigt.',
  'dashboard.subscription.cancelFailed': 'Kündigung fehlgeschlagen',
  'dashboard.subscription.reactivate': 'Reaktivieren',
  'dashboard.subscription.reactivateSuccess': 'Ihr Abo wurde erfolgreich reaktiviert!',
  'dashboard.subscription.reactivateFailed': 'Reaktivierung fehlgeschlagen',
  'dashboard.subscription.pauseSuccess': 'Ihr Abo wurde pausiert.',
  'dashboard.subscription.pauseFailed': 'Pausieren fehlgeschlagen',
  'dashboard.subscription.downgradePending': 'Downgrade wartet auf Genehmigung durch den Administrator.',
  'dashboard.subscription.downgradeRequested': 'Downgrade-Anfrage gestellt.',
  'dashboard.subscription.planChangedTo': 'Plan erfolgreich auf {{plan}} geändert!',
  'dashboard.subscription.newPlan': 'neuen Plan',
  'dashboard.subscription.planChangeFailed': 'Planwechsel fehlgeschlagen',
  'dashboard.subscription.tabs.overview': 'Übersicht',
  'dashboard.subscription.tabs.billing': 'Rechnungsadresse',
  'dashboard.subscription.tabs.history': 'Zahlungshistorie',
  'dashboard.subscription.status.active': 'aktiv',
  'dashboard.subscription.status.cancelled': 'gekündigt',
  'dashboard.subscription.status.paused': 'pausiert',
  'dashboard.subscription.status.overdue': 'überfällig',
  'dashboard.subscription.status.label': 'Status',
  'dashboard.subscription.memberSince': 'Mitglied seit {{date}}',
  'dashboard.subscription.chfBase': 'CHF {{amount}} Basis',
  'dashboard.subscription.monthAbbrev': 'Monat',
  'dashboard.subscription.creditsPerMonth': 'Credits / Monat',
  'dashboard.subscription.freeAccount': 'Gratis-Account',
  'dashboard.subscription.cancelSubscription': 'Abo kündigen',
  'dashboard.subscription.downloadInvoices': 'Rechnungen herunterladen',
  'dashboard.subscription.invoicesAvailable': '{{count}} Rechnungen als PDF verfügbar',
  'dashboard.subscription.accountSettings': 'Konto-Einstellungen',
  'dashboard.subscription.accountSettingsDesc': 'Profil, Benachrichtigungen & mehr',
  'dashboard.subscription.billing.recipient': 'Rechnungsempfänger',
  'dashboard.subscription.billing.addressNote': 'Adressänderungen sind derzeit nur im Profil verfügbar.',
  'dashboard.subscription.history.title': 'Zahlungshistorie',
  'dashboard.subscription.history.subtitle': 'Alle Rechnungen als PDF herunterladen',
  'dashboard.subscription.history.downloadAll': 'Alle herunterladen',
  'dashboard.subscription.history.eurNote': 'Rechnungen werden immer in CHF ausgestellt. Angezeigte EUR-Beträge dienen nur zur Orientierung.',
  'dashboard.subscription.history.noInvoices': 'Noch keine Rechnungen vorhanden',
  'dashboard.subscription.history.col.date': 'Datum',
  'dashboard.subscription.history.col.type': 'Typ',
  'dashboard.subscription.history.col.net': 'Netto',
  'dashboard.subscription.history.col.vat': 'MwSt.',
  'dashboard.subscription.history.col.total': 'Gesamt',
  'dashboard.subscription.history.col.pdf': 'PDF',
  'dashboard.subscription.history.invoicesCount': '{{count}} Rechnungen',
  'dashboard.subscription.history.totalAmount': 'Gesamtbetrag',
  'dashboard.subscription.switching': 'Wird gewechselt...',
  'dashboard.subscription.cancelling': 'Kündige...',
  'dashboard.subscription.cancelNow': 'Jetzt kündigen',
  'dashboard.subscription.eurNotice.prefix': 'Preise werden in',
  'dashboard.subscription.eurNotice.currency': 'Euro',
  'dashboard.subscription.eurNotice.suffix': 'angezeigt',
  'dashboard.subscription.eurNotice.rate': 'Kurs',
  'dashboard.subscription.eurNotice.currentRate': 'Aktueller Kurs',
  'dashboard.subscription.eurChangePlanNote': 'Preise in EUR angezeigt ({{note}}). Abrechnung erfolgt in CHF.',
  'dashboard.subscription.cancelModal.title': 'Abo wirklich kündigen?',
  'dashboard.subscription.cancelModal.subtitle': 'Die Kündigung wird zum Ende des Abrechnungszeitraums wirksam.',
  'dashboard.subscription.cancelModal.point1': 'Nach Ablauf keine Credits mehr',
  'dashboard.subscription.cancelModal.point2': 'Premium-Features werden entfernt',
  'dashboard.subscription.cancelModal.pauseTitle': 'Alternativ: Abo pausieren?',
  'dashboard.subscription.cancelModal.pauseDesc': 'Pausieren Sie Ihr Abo stattdessen und behalten Sie Ihre Daten.',
  'dashboard.subscription.cancelModal.pauseCta': 'Lieber pausieren',
  'dashboard.subscription.cancelModal.reasonLabel': 'Kündigungsgrund',
  'dashboard.subscription.cancelModal.selectReason': 'Bitte auswählen...',
  'dashboard.subscription.cancelModal.reasonTooExpensive': 'Zu teuer',
  'dashboard.subscription.cancelModal.reasonNotUsing': 'Nutze es nicht genug',
  'dashboard.subscription.cancelModal.reasonMissing': 'Fehlende Features',
  'dashboard.subscription.cancelModal.reasonAlternative': 'Alternative gefunden',
  'dashboard.subscription.cancelModal.reasonOther': 'Sonstiges',
  'dashboard.subscription.cancelModal.confirmLabel': 'Bestätigung: Geben Sie "{{keyword}}" ein *',
  'dashboard.subscription.invoice.heading': 'RECHNUNG',
  'dashboard.subscription.invoice.from': 'VON',
  'dashboard.subscription.invoice.to': 'AN',
  'dashboard.subscription.invoice.vatId': 'USt-IdNr',
  'dashboard.subscription.invoice.date': 'Rechnungsdatum',
  'dashboard.subscription.invoice.number': 'Rechnungsnummer',
  'dashboard.subscription.invoice.paymentStatus': 'Zahlungsstatus',
  'dashboard.subscription.invoice.description': 'BESCHREIBUNG',
  'dashboard.subscription.invoice.quantity': 'MENGE',
  'dashboard.subscription.invoice.price': 'PREIS',
  'dashboard.subscription.invoice.amount': 'BETRAG',
  'dashboard.subscription.invoice.subscriptionLabel': 'Abonnement',
  'dashboard.subscription.invoice.subtotal': 'Zwischensumme',
  'dashboard.subscription.invoice.total': 'Gesamtbetrag',
  'dashboard.subscription.invoice.downloaded': 'Rechnung {{invoiceNo}} heruntergeladen!',
  'dashboard.subscription.invoice.pdfError': 'Fehler beim Erstellen der PDF.',

  // Dashboard — shared transaction status labels
  'dashboard.txStatus.completed': 'Abgeschlossen',
  'dashboard.txStatus.pending': 'Ausstehend',
  'dashboard.txStatus.failed': 'Fehlgeschlagen',
  'dashboard.txStatus.active': 'Aktiv',
  'dashboard.txStatus.cancelled': 'Gekündigt',
  'dashboard.txStatus.refunded': 'Erstattet',
  'dashboard.txStatus.paused': 'Pausiert',
  'dashboard.txStatus.overdue': 'Überfällig',

  // Dashboard — shared transaction type labels
  'dashboard.txType.subscription': 'Abonnement',
  'dashboard.txType.upgrade': 'Upgrade',
  'dashboard.txType.downgrade': 'Downgrade',
  'dashboard.txType.refund': 'Erstattung',
  'dashboard.txType.bonus': 'Bonus',
  'dashboard.txType.deduction': 'Abzug',
  'dashboard.txType.payment': 'Zahlung',
  'dashboard.txType.reset': 'Zurücksetzung',
  'dashboard.txType.credit_purchase': 'Credit-Kauf',
  'dashboard.txType.plan_change': 'Planwechsel',

  // E-Mail-Verifizierungsdialog
  'dashboard.verify.title': 'Bestätigen Sie Ihre E-Mail',
  'dashboard.verify.subtitle': 'Ein schneller Schritt, um Ihr Konto zu aktivieren',
  'dashboard.verify.instruction': 'Wir haben einen Bestätigungslink gesendet an:',
  'dashboard.verify.hint':
    'Öffnen Sie die E-Mail und klicken Sie auf die Schaltfläche, um zu aktivieren. Diese Seite wird automatisch freigeschaltet. Prüfen Sie Ihren Spam-Ordner, falls die E-Mail nicht innerhalb einer Minute eintrifft.',
  'dashboard.verify.checking': 'Prüfung läuft…',
  'dashboard.verify.checkNow': 'Ich habe auf den Link geklickt',
  'dashboard.verify.sending': 'Senden…',
  'dashboard.verify.resend': 'E-Mail erneut senden',
  'dashboard.verify.skip': 'Später bestätigen',
  'dashboard.verify.logout': 'Abmelden',
  'dashboard.verify.autoCheck':
    'Wir prüfen alle 5 Sekunden – die Seite wird freigeschaltet, sobald Sie bestätigt haben.',
  'dashboard.verify.resendSuccess': 'Bestätigungs-E-Mail an {{email}} gesendet.',
  'dashboard.verify.resendError': 'Erneutes Senden fehlgeschlagen. Bitte versuchen Sie es in einem Moment erneut.',

  // Analyse-Karte (KI-Analyse-Ausgabekarte)
  'dashboard.analysisCard.creditsLabel_one': '{{count}} Credit',
  'dashboard.analysisCard.creditsLabel_other': '{{count}} Credits',
  'dashboard.analysisCard.creditsLabel': '{{count}} Credits',
  'dashboard.analysisCard.industryBenchmark': 'Branchen-Benchmark',
  'dashboard.analysisCard.topPercent': 'Top {{pct}}%',
  'dashboard.analysisCard.industryAvg': 'Branchendurchschnitt',
  'dashboard.analysisCard.top10Percent': 'Top 10%',
  'dashboard.analysisCard.you': 'Sie',
  'dashboard.analysisCard.avgShort': 'Ø',
  'dashboard.analysisCard.competitorAnalysis': 'Wettbewerbsanalyse',
  'dashboard.analysisCard.entryPoint': 'Ihr Einstiegspunkt',
  'dashboard.analysisCard.sources': 'Quellen',
  'dashboard.analysisCard.creditsUsageTip_one':
    'Diese Analyse hat {{count}} Credit verbraucht · Tipp: präzise Beschreibungen sparen Credits',
  'dashboard.analysisCard.creditsUsageTip_other':
    'Diese Analyse hat {{count}} Credits verbraucht · Tipp: präzise Beschreibungen sparen Credits',
  'dashboard.analysisCard.creditsUsageTip':
    'Diese Analyse hat {{count}} Credits verbraucht · Tipp: präzise Beschreibungen sparen Credits',
  'dashboard.analysisCard.recheck': 'Neu prüfen',
  'dashboard.analysisCard.metrics.demand': 'Nachfrage',
  'dashboard.analysisCard.metrics.willingnessToPay': 'Zahlungsbereitschaft',
  'dashboard.analysisCard.metrics.differentiation': 'Differenzierung',
  'dashboard.analysisCard.metrics.feasibility': 'Machbarkeit',
  'dashboard.analysisCard.metrics.risk': 'Risiko',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Willkommen zurück, {{name}}',
  'dashboard.overview.subtitle': 'Hier ist eine schnelle Übersicht deiner Aktivitäten',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Verbleibende Credits',
  'dashboard.stats.totalAnalyses': 'Analysen gesamt',
  'dashboard.stats.goodRatings': 'Positive Bewertungen',
  'dashboard.stats.nextReset': 'Nächster Reset in',
  'dashboard.stats.days': 'Tagen',
  'dashboard.stats.loadError': 'Statistiken konnten nicht geladen werden',

  // Quick Actions
  'dashboard.quickActions.title': 'Schnellaktionen',
  'dashboard.quickActions.checkNewIdea': 'Idee prüfen',
  'dashboard.quickActions.checkNewIdeaDesc': 'Eine bestehende Geschäftsidee analysieren',
  'dashboard.quickActions.generateIdea': 'Idee generieren',
  'dashboard.quickActions.generateIdeaDesc': 'Eine neue profitable Nische finden',
  'dashboard.quickActions.builderBriefing': 'Builder-Briefing',
  'dashboard.quickActions.builderBriefingDesc': 'Eine Idee in ein entwicklerfertiges Briefing verwandeln',
  'dashboard.quickActions.premiumOnly': 'Nur für Builder',

  // Chat Header
  'chat.title': 'KI-Nischen-Assistent',
  'chat.subtitle': 'Stelle Fragen zu Nischen. Ich bewerte kritisch und ehrlich.',
  'chat.creditsLabel': 'Credits',

  // Chat Welcome
  'chat.welcomeTitle': 'Willkommen beim KI-Nischen-Assistenten',
  'chat.welcomeDesc': 'Beschreibe deine Idee oder frage nach einer Nische. Ich bewerte sie ehrlich: Gut, Mittel oder Schlecht.',
  'chat.aiWelcome': 'Hi! Beschreibe deine Idee oder frage mich nach einer Nische. Ich gebe dir eine klare und ehrliche Bewertung.',

  // Chat Suggestions
  'chat.suggestion1': 'Ich möchte ein SaaS-Tool für Freelancer zur Rechnungsverwaltung bauen. Ist das eine gute Nische?',
  'chat.suggestion2': 'Finde mir ein Online-Business mit geringer Konkurrenz, das ich mit 500 $ und ohne Programmierkenntnisse starten kann.',
  'chat.suggestion3': 'Bewerte das: eine KI-gestützte App für Essensplanung für vielbeschäftigte Eltern mit Ernährungseinschränkungen.',
  'chat.suggestion4': 'Ich möchte auf Etsy digitale Vorlagen für Kleinunternehmer verkaufen. Analysiere diese Nische ehrlich.',
  'chat.suggestion5': 'Ist ein Nischen-Newsletter für Einzel-Immobilienmakler in Kleinstädten ein tragfähiges Geschäft?',
  'chat.suggestion6': 'Nenne mir drei unterversorgte B2B-Nischen, für die heute kaum Software existiert.',
  'chat.suggestion7': 'Ich habe eine Idee für eine Abo-Box für junge Väter. Bewerte die Zahlen ehrlich.',
  'chat.suggestion8': 'Welche profitablen Micro-SaaS-Ideen kann ich allein in unter 90 Tagen bauen?',
  'chat.suggestion9': 'Bewerte das: eine Mobile-App, die Sprachnotizen in strukturierte Sales-CRM-Einträge umwandelt.',
  'chat.suggestion10': 'Ich möchte ein Online-Coaching-Programm für Gen-Z-Freelancer starten. Gute Nische oder gesättigt?',
  'chat.suggestion11': 'Analysiere einen Done-for-You-LinkedIn-Content-Service für B2B-Gründer für 1.500 $/Monat.',
  'chat.suggestion12': 'Finde mir eine langweilige Nische mit wiederkehrenden Einnahmen und niedrigen Marketingkosten.',

  // Chat Actions
  'chat.newConversation': 'Neue Unterhaltung',
  'chat.today': 'Heute',
  'chat.yesterday': 'Gestern',
  'chat.thisWeek': 'Diese Woche',
  'chat.thisMonth': 'Diesen Monat',
  'chat.older': 'Älter',
  'chat.messages': 'Nachrichten',
  'chat.renameConversation': 'Umbenennen',
  'chat.deleteConversation': 'Löschen',
  'chat.cancel': 'Abbrechen',
  'chat.rename': 'Umbenennen',
  'chat.delete': 'Löschen',
  'chat.favorite': 'Favorit hinzufügen',
  'chat.unfavorite': 'Favorit entfernen',
  'chat.searchSessions': 'Unterhaltungen durchsuchen...',
  'chat.noResults': 'Keine Ergebnisse gefunden',
  'chat.noSessions': 'Noch keine Unterhaltungen',
  'chat.enterNewName': 'Neuen Namen eingeben...',
  'chat.deleteConfirmMessage': 'Bist du sicher, dass du diese Unterhaltung löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Stelle deine Frage… (kostet 30 Credits)',
  'chat.send': 'Senden',
  'chat.voice': 'Sprechen',
  'chat.errorNotEnoughCredits': 'Nicht genügend Credits. Bitte upgrade deinen Plan oder warte auf den nächsten Reset.',
  'chat.errorAiFailed': 'KI-Antwort fehlgeschlagen. Es wurden keine Credits abgezogen.',
  'chat.errorRateLimit': 'Zu viele Anfragen. Bitte warte einen Moment.',

  // Ratings
  'rating.good': 'Gut',
  'rating.medium': 'Mittel',
  'rating.bad': 'Schlecht',

  // Auth Page
  'auth.branding.headline1': 'Nicht jede Idee ist gut.',
  'auth.branding.headline2': 'Wir sagen es dir ehrlich.',
  'auth.branding.subtitle': 'Eine Entscheidungs-KI für Geschäfts-Nischen. Klar. Kritisch. Ohne Schönreden.',
  'auth.benefits.privacy.title': '100% Privat',
  'auth.benefits.privacy.desc': 'Deine Ideen bleiben vollständig privat und sicher.',
  'auth.benefits.honest.title': 'Ehrliche KI',
  'auth.benefits.honest.desc': 'Kein Schönreden – nur klares, kritisches Feedback.',
  'auth.benefits.fast.title': 'Schnelle Ergebnisse',
  'auth.benefits.fast.desc': 'Erhalte Klarheit über deine Nische in Minuten.',
  'auth.trust.users': 'Aktive Nutzer',
  'auth.trust.ideas': 'Analysierte Ideen',
  'auth.trust.rating': 'Nutzerbewertung',
  'auth.login.title': 'Anmelden',
  'auth.login.headline': 'Willkommen zurück',
  'auth.login.subtitle': 'Melde dich an, um fortzufahren.',
  'auth.login.forgotPassword': 'Passwort vergessen?',
  'auth.login.submit': 'Anmelden',
  'auth.login.noAccount': 'Noch kein Konto?',
  'auth.login.signUp': 'Registrieren',
  'auth.register.title': 'Registrieren',
  'auth.register.headline': 'Konto erstellen',
  'auth.register.subtitle': 'Starte heute mit der Analyse deiner Geschäftsideen.',
  'auth.register.submit': 'Konto erstellen',
  'auth.register.hasAccount': 'Bereits ein Konto?',
  'auth.register.signIn': 'Anmelden',
  'auth.fields.name': 'Vollständiger Name',
  'auth.fields.email': 'E-Mail-Adresse',
  'auth.fields.password': 'Passwort',
  'auth.fields.confirmPassword': 'Passwort bestätigen',
  'auth.fields.selectPlan': 'Wähle dein Paket',
  'auth.placeholders.name': 'Gib deinen Namen ein',
  'auth.placeholders.email': 'Gib deine E-Mail ein',
  'auth.placeholders.password': 'Gib dein Passwort ein',
  'auth.placeholders.confirmPassword': 'Bestätige dein Passwort',
  'auth.terms.accept': 'Ich akzeptiere die',
  'auth.terms.terms': 'AGB',
  'auth.privacy.accept': 'Ich akzeptiere die',
  'auth.privacy.policy': 'Datenschutzerklärung',
  'auth.errors.nameRequired': 'Name ist erforderlich',
  'auth.errors.emailRequired': 'E-Mail ist erforderlich',
  'auth.errors.emailInvalid': 'Bitte gib eine gültige E-Mail ein',
  'auth.errors.passwordRequired': 'Passwort ist erforderlich',
  'auth.errors.passwordLength': 'Passwort muss mindestens 8 Zeichen haben',
  'auth.errors.passwordMismatch': 'Passwörter stimmen nicht überein',
  'auth.errors.network': 'Verbindung zum Server fehlgeschlagen. Bitte versuche es erneut oder nutze die E-Mail-Registrierung.',
  'auth.errors.appleUnavailable': 'Apple-Anmeldung ist derzeit nicht verfügbar. Bitte registriere dich stattdessen mit deiner E-Mail.',
  'auth.loading': 'Bitte warten...',
  'auth.or': 'oder fortfahren mit',
  'auth.social.google': 'Mit Google fortfahren',
  'auth.social.apple': 'Mit Apple fortfahren',

  // Email Verification
  'auth.verification.title': 'E-Mail bestätigen',
  'auth.verification.headline': 'Überprüfe dein Postfach',
  'auth.verification.subtitle': 'Wir haben dir einen Bestätigungscode gesendet an:',
  'auth.verification.codeLabel': 'Bestätigungscode',
  'auth.verification.codePlaceholder': '6-stelligen Code eingeben',
  'auth.verification.submit': 'E-Mail bestätigen',
  'auth.verification.resend': 'Code erneut senden',
  'auth.verification.resendIn': 'Erneut senden in',
  'auth.verification.seconds': 'Sekunden',
  'auth.verification.success': 'E-Mail erfolgreich bestätigt!',
  'auth.verification.error': 'Ungültiger Code. Bitte versuche es erneut.',
  'auth.verification.expired': 'Code abgelaufen. Bitte fordere einen neuen an.',
  'auth.verification.sent': 'Neuer Code wurde gesendet!',
  'auth.verification.checkSpam': 'Nicht erhalten? Überprüfe deinen Spam-Ordner.',

  // Forgot Password
  'auth.forgot.title': 'Passwort vergessen',
  'auth.forgot.headline': 'Passwort zurücksetzen',
  'auth.forgot.subtitle': 'Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen.',
  'auth.forgot.submit': 'Link senden',
  'auth.forgot.backToLogin': 'Zurück zur Anmeldung',
  'auth.forgot.success': 'E-Mail gesendet!',
  'auth.forgot.successMessage': 'Wir haben dir eine E-Mail mit Anweisungen zum Zurücksetzen deines Passworts gesendet.',
  'auth.forgot.checkInbox': 'Überprüfe dein Postfach',

  // Reset Password
  'auth.reset.title': 'Neues Passwort',
  'auth.reset.headline': 'Neues Passwort festlegen',
  'auth.reset.subtitle': 'Gib dein neues Passwort ein.',
  'auth.reset.newPassword': 'Neues Passwort',
  'auth.reset.confirmNewPassword': 'Neues Passwort bestätigen',
  'auth.reset.submit': 'Passwort ändern',
  'auth.reset.success': 'Passwort erfolgreich geändert!',
  'auth.reset.successMessage': 'Du kannst dich jetzt mit deinem neuen Passwort anmelden.',
  'auth.reset.loginNow': 'Jetzt anmelden',

  // Legal Pages
  'legal.backToAuth': 'Zurück zur Anmeldung',
  'legal.allRightsReserved': 'Alle Rechte vorbehalten.',
  
  // Terms Page
  'legal.terms.title': 'Allgemeine Geschäftsbedingungen',
  'legal.terms.lastUpdated': 'Zuletzt aktualisiert',
  'legal.terms.section1.title': '1. Geltungsbereich',
  'legal.terms.section1.content': 'Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge zwischen NicheFinder (nachfolgend "Anbieter") und dem Nutzer (nachfolgend "Kunde") über die Nutzung der KI-gestützten Nischen-Analyse-Plattform.',
  'legal.terms.section2.title': '2. Leistungsbeschreibung',
  'legal.terms.section2.content': 'Der Anbieter stellt eine KI-basierte Plattform zur Verfügung, die Geschäftsideen und Nischen analysiert und bewertet. Die Leistungen umfassen:',
  'legal.terms.section2.item1': 'KI-gestützte Analyse von Geschäftsideen',
  'legal.terms.section2.item2': 'Bewertung von Marktpotenzial und Wettbewerb',
  'legal.terms.section2.item3': 'Generierung von Nischen-Vorschlägen',
  'legal.terms.section2.item4': 'Erstellung von Entwickler-Briefings (Builder-Paket)',
  'legal.terms.section3.title': '3. Vertragsschluss und Registrierung',
  'legal.terms.section3.content': 'Der Vertrag kommt durch die Registrierung auf der Plattform und die Auswahl eines Pakets zustande. Der Kunde versichert:',
  'legal.terms.section3.item1': 'Volljährigkeit und volle Geschäftsfähigkeit',
  'legal.terms.section3.item2': 'Wahrheitsgemäße Angaben bei der Registrierung',
  'legal.terms.section3.item3': 'Sichere Aufbewahrung der Zugangsdaten',
  'legal.terms.section4.title': '4. Credits und Abrechnung',
  'legal.terms.section4.content': 'Die Nutzung der KI-Funktionen erfolgt über ein Credit-System. Jede KI-Anfrage kostet 30 Credits. Credits werden nur bei erfolgreicher Antwort abgezogen. Nicht genutzte Credits verfallen am Ende des Abrechnungszeitraums und werden nicht erstattet.',
  'legal.terms.section5.title': '5. Haftungsausschluss',
  'legal.terms.section5.content': 'Die KI-Bewertungen dienen ausschließlich als Entscheidungshilfe und stellen keine Garantie für geschäftlichen Erfolg dar. Der Anbieter haftet nicht für Entscheidungen, die auf Basis der KI-Analysen getroffen werden. Die Haftung für Vorsatz und grobe Fahrlässigkeit bleibt unberührt.',
  'legal.terms.section6.title': '6. Datenschutz und Vertraulichkeit',
  'legal.terms.section6.content': 'Alle eingegebenen Geschäftsideen werden vertraulich behandelt und nicht an Dritte weitergegeben. Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung und den geltenden Datenschutzgesetzen.',
  'legal.terms.section7.title': '7. Kündigung',
  'legal.terms.section7.content': 'Der Kunde kann sein Abonnement jederzeit zum Ende des aktuellen Abrechnungszeitraums kündigen. Bei Verstößen gegen diese AGB behält sich der Anbieter das Recht vor, den Zugang zur Plattform zu sperren.',
  'legal.terms.section8.title': '8. Schlussbestimmungen',
  'legal.terms.section8.content': 'Es gilt Schweizer Recht. Gerichtsstand ist Zürich, Schweiz. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.',
  'legal.terms.contact.title': 'Fragen zu den AGB?',
  'legal.terms.contact.content': 'Bei Fragen zu diesen Allgemeinen Geschäftsbedingungen kontaktieren Sie uns bitte unter:',

  // Privacy Page
  'legal.privacy.title': 'Datenschutzerklärung',
  'legal.privacy.section1.title': '1. Verantwortlicher',
  'legal.privacy.section1.content': 'Verantwortlich für die Datenverarbeitung auf dieser Website ist NicheFinder, Zürich, Schweiz. Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften.',
  'legal.privacy.section2.title': '2. Erhobene Daten',
  'legal.privacy.section2.content': 'Wir erheben und verarbeiten folgende personenbezogene Daten:',
  'legal.privacy.section2.item1': 'Registrierungsdaten: Name, E-Mail-Adresse, Passwort (verschlüsselt)',
  'legal.privacy.section2.item2': 'Nutzungsdaten: IP-Adresse, Browsertyp, Zugriffszeiten',
  'legal.privacy.section2.item3': 'Geschäftsideen und Nischen-Anfragen (anonymisiert gespeichert)',
  'legal.privacy.section2.item4': 'Zahlungsinformationen (über sichere Drittanbieter)',
  'legal.privacy.section3.title': '3. Zweck der Datenverarbeitung',
  'legal.privacy.section3.content': 'Ihre Daten werden für folgende Zwecke verwendet:',
  'legal.privacy.section3.item1': 'Bereitstellung und Verbesserung unserer KI-Dienste',
  'legal.privacy.section3.item2': 'Kontoverwaltung und Authentifizierung',
  'legal.privacy.section3.item3': 'Abrechnung und Zahlungsabwicklung',
  'legal.privacy.section4.title': '4. Datensicherheit',
  'legal.privacy.section4.content': 'Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen Manipulation, Verlust, Zerstörung oder unbefugten Zugriff zu schützen. Alle Datenübertragungen erfolgen verschlüsselt über SSL/TLS.',
  'legal.privacy.section5.title': '5. Vertraulichkeit Ihrer Geschäftsideen',
  'legal.privacy.section5.content': 'Ihre eingegebenen Geschäftsideen und Nischen-Anfragen werden streng vertraulich behandelt. Sie werden nicht an Dritte weitergegeben, nicht für Trainingszwecke verwendet und können auf Wunsch vollständig gelöscht werden. Ihre Ideen gehören Ihnen.',
  'legal.privacy.section6.title': '6. Ihre Rechte',
  'legal.privacy.section6.content': 'Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:',
  'legal.privacy.section6.item1': 'Recht auf Auskunft über gespeicherte Daten',
  'legal.privacy.section6.item2': 'Recht auf Berichtigung unrichtiger Daten',
  'legal.privacy.section6.item3': 'Recht auf Löschung Ihrer Daten',
  'legal.privacy.section6.item4': 'Recht auf Datenübertragbarkeit',
  'legal.privacy.section7.title': '7. Cookies',
  'legal.privacy.section7.content': 'Unsere Website verwendet nur technisch notwendige Cookies für die Authentifizierung und Sitzungsverwaltung. Wir verwenden keine Tracking-Cookies oder Analyse-Tools von Drittanbietern ohne Ihre ausdrückliche Zustimmung.',
  'legal.privacy.section8.title': '8. Änderungen dieser Datenschutzerklärung',
  'legal.privacy.section8.content': 'Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um sie an geänderte Rechtslagen oder bei Änderungen des Dienstes anzupassen. Die aktuelle Version finden Sie stets auf dieser Seite.',
  'legal.privacy.contact.title': 'Fragen zum Datenschutz?',
  'legal.privacy.contact.content': 'Bei Fragen zur Verarbeitung Ihrer personenbezogenen Daten kontaktieren Sie uns bitte unter:',

  passwordStrength: {
    label: 'Passwortstärke',
    weak: 'Schwach',
    medium: 'Mittel',
    strong: 'Stark',
    veryStrong: 'Sehr stark',
    minLength: 'Min. 8 Zeichen',
    uppercase: 'Grossbuchstabe',
    number: 'Zahl',
    special: 'Sonderzeichen',
  },

  trial: {
    subtitle: 'Kostenlose Testversion',
    upgrade: 'Jetzt upgraden',
    creditsRemaining: 'Credits übrig',
    inputHint: 'Testversion - Keine Gesprächshistorie verfügbar',
    banner: {
      title: '7-Tage-Testversion aktiv',
      remaining: 'Noch {{days}} Tage übrig',
      credits: 'Credits verfügbar',
      upgradeNow: 'Jetzt upgraden'
    },
    welcome: {
      title: 'Willkommen zur kostenlosen Testversion!',
      desc: 'Teste unseren KI-Assistenten 7 Tage lang kostenlos mit 100 Credits. Stelle Fragen und entdecke die Möglichkeiten!'
    },
    info: {
      title: 'Testversion-Einschränkungen',
      credits: '100 Credits für 7 Tage',
      noHistory: 'Keine Gesprächshistorie',
      noSettings: 'Eingeschränkte Funktionen',
      upgrade: 'Upgrade für volle Features'
    }
  },

  // Admin Dashboard
  'admin.common.all': 'Alle',
  'admin.common.cancel': 'Abbrechen',
  'admin.common.save': 'Speichern',
  'admin.common.saving': 'Speichert...',
  'admin.common.loading': 'Lädt...',
  'admin.common.create': 'Erstellen',
  'admin.common.edit': 'Bearbeiten',
  'admin.common.delete': 'Löschen',
  'admin.common.close': 'Schliessen',
  'admin.common.back': 'Zurück',
  'admin.common.next': 'Weiter',
  'admin.common.change': 'Ändern',
  'admin.common.error': 'Fehler',

  // Admin Login
  'admin.login.adminLogin': 'Admin-Anmeldung',
  'admin.login.emailLabel': 'Admin E-Mail',
  'admin.login.passwordLabel': 'Admin-Passwort',
  'admin.login.notAdminAccount': 'Dies ist kein Admin-Konto.',
  'admin.login.invalidCredentials': 'Ungültige Admin-Zugangsdaten. Bitte überprüfen Sie E-Mail und Passwort.',
  'admin.login.signingIn': 'Anmeldung läuft...',
  'admin.login.submit': 'Als Admin anmelden',
  'admin.login.backToHome': 'Zurück zur Startseite',
  'admin.login.securityNotice': 'Alle Admin-Aktivitäten werden protokolliert',

  // Admin Header
  'admin.header.title': 'Admin-Dashboard',
  'admin.header.subtitle': 'Verwaltungszentrale',
  'admin.header.superAdmin': 'Super-Admin',
  'admin.header.logout': 'Abmelden',

  // Admin Dashboard Tabs
  'admin.dashboard.tabs.users': 'Benutzerverwaltung',
  'admin.dashboard.tabs.downgrades': 'Downgrades',
  'admin.dashboard.tabs.tips': 'Tipp des Tages',
  'admin.dashboard.tabs.coupons': 'Gutschein-Codes',
  'admin.dashboard.tabs.website': 'Website-Editor',
  'admin.dashboard.tabs.ai': 'KI-Einstellungen',
  'admin.dashboard.tabs.transactions': 'Transaktionslog',
  'admin.dashboard.tabs.stats': 'Statistiken',
  'admin.dashboard.tabs.usage': 'Usage',

  // Admin Stats
  'admin.stats.loadError': 'Fehler beim Laden der Statistiken',
  'admin.stats.noData': 'Keine Statistikdaten verfügbar',
  'admin.stats.totalUsers': 'Gesamte Benutzer',
  'admin.stats.revenue30d': 'Umsatz (30 Tage)',
  'admin.stats.activeSubs': 'Aktive Abos',
  'admin.stats.average': 'Durchschnitt',
  'admin.stats.revenuePerUser': 'Umsatz pro Benutzer',
  'admin.stats.totalRevenue': 'Gesamt-Umsatz',
  'admin.stats.ideasTotal': 'Analysierte Ideen',
  'admin.stats.pausedSubs': 'Pausierte Abos',
  'admin.stats.churnRate': 'Kündigungsrate',
  'admin.stats.planDistribution': 'Paket-Verteilung',
  'admin.stats.usersCount': '{{count}} Benutzer',
  'admin.stats.revenueByPlan': 'Umsatz nach Paket',
  'admin.stats.subStatusOverview': 'Abo-Status Übersicht',
  'admin.stats.statusActive': 'Aktiv',
  'admin.stats.statusCancelled': 'Gekündigt',
  'admin.stats.statusPaused': 'Pausiert',
  'admin.stats.statusOverdue': 'Überfällig',
  'admin.stats.couponStats': 'Gutschein-Statistiken',
  'admin.stats.totalRedemptions': 'Gesamte Einlösungen',
  'admin.stats.activeCoupons': 'Aktive Gutscheine',
  'admin.stats.registrationRedemptions': 'Registrierungs-Einlösungen',
  'admin.stats.trialRedemptions': 'Test-Zugangs-Einlösungen',
  'admin.stats.couponDistribution': 'Gutschein-Verteilung',
  'admin.stats.registrationCoupons': 'Registrierungs-Gutscheine',
  'admin.stats.trialCoupons': 'Test-Zugangs-Gutscheine',
  'admin.stats.expiredInactive': 'Abgelaufen/Inaktiv',
  'admin.stats.topCoupons': 'Top Gutscheine nach Einlösungen',
  'admin.stats.redemptions': 'Einlösungen',
  'admin.stats.noCouponsRedeemed': 'Noch keine Gutscheine eingelöst',

  // Admin Users
  'admin.users.loadError': 'Fehler beim Laden der Benutzer',
  'admin.users.searchPlaceholder': 'Benutzer suchen (E-Mail oder Name)...',
  'admin.users.allPlans': 'Alle Pakete',
  'admin.users.colUser': 'Benutzer',
  'admin.users.colPlan': 'Paket',
  'admin.users.colStatus': 'Abo-Status',
  'admin.users.colCredits': 'Credits',
  'admin.users.colRegistered': 'Registriert',
  'admin.users.colActions': 'Aktionen',
  'admin.users.statusActive': 'Aktiv',
  'admin.users.statusCancelled': 'Gekündigt',
  'admin.users.statusPaused': 'Pausiert',
  'admin.users.statusOverdue': 'Überfällig',
  'admin.users.statusNone': 'Kein Abo',
  'admin.users.free': 'Gratis',
  'admin.users.adminBadge': 'Admin',
  'admin.users.unlimited': 'Unbegrenzt',
  'admin.users.viewDetails': 'Details anzeigen',
  'admin.users.changePlan': 'Paket ändern',
  'admin.users.grantCredits': 'Credits gutschreiben',
  'admin.users.revokeFree': 'Gratis-Status entfernen',
  'admin.users.grantFree': 'Gratis-Zugang gewähren',
  'admin.users.grantFreeTitle': 'Gratis-Zugang gewähren',
  'admin.users.unblock': 'Entsperren',
  'admin.users.block': 'Blockieren',
  'admin.users.unblockTitle': 'Benutzer entsperren',
  'admin.users.blockTitle': 'Benutzer blockieren',
  'admin.users.unblockMessage': 'Der Benutzer kann sich wieder anmelden.',
  'admin.users.blockMessage': 'Der Benutzer wird ausgeloggt und kann sich nicht mehr anmelden.',
  'admin.users.blockedSuccess': '{{name}} wurde blockiert',
  'admin.users.unblockedSuccess': '{{name}} wurde entsperrt',
  'admin.users.blockError': 'Fehler beim Blockieren',
  'admin.users.confirmRevokeFree': 'Gratis-Status von {{name}} entfernen?',
  'admin.users.revokedFreeSuccess': 'Gratis-Status von {{name}} entfernt',
  'admin.users.grantedFreeSuccess': '{{name}} erhält {{duration}} {{unit}} Gratis-Zugang',
  'admin.users.grantError': 'Fehler beim Gewähren',
  'admin.users.daysUnit': 'Tag(e)',
  'admin.users.monthsUnit': 'Monat(e)',
  'admin.users.duration': 'Dauer',
  'admin.users.days': 'Tage',
  'admin.users.months': 'Monate',
  'admin.users.grantSubmit': 'Gewähren',
  'admin.users.planChangedSuccess': '{{name}} auf {{plan}} geändert',
  'admin.users.planChangeError': 'Fehler beim Paket-Wechsel',
  'admin.users.newPlan': 'Neues Paket',
  'admin.users.creditsPerMonth': '{{credits}} Credits/Monat',
  'admin.users.creditsGrantedSuccess': '{{count}} Credits für {{name}} gutgeschrieben',
  'admin.users.creditGrantSubmit': 'Gutschreiben',
  'admin.users.amount': 'Menge',
  'admin.users.credits': 'Credits',
  'admin.users.current': 'Aktuell',
  'admin.users.currentPlan': 'Aktuelles Paket',
  'admin.users.status': 'Status',
  'admin.users.subInfo': 'Abo-Informationen',
  'admin.users.noUsers': 'Keine Benutzer gefunden.',
  'admin.users.total': 'Gesamt: {{count}} Benutzer',
  'admin.users.activeCount': '{{count}} aktiv',
  'admin.users.cancelledCount': '{{count}} gekündigt',
  'admin.users.freeAccess': 'Gratis-Zugang',
  'admin.users.validUntil': 'Gültig bis',
  'admin.users.validUntilLabel': 'Gültig bis',
  'admin.users.cancelled': 'Abo gekündigt',
  'admin.users.cancelledDate': 'Kündigungsdatum',
  'admin.users.reason': 'Grund',
  'admin.users.contact': 'Kontakt',
  'admin.users.verified': 'Verifiziert',
  'admin.users.notVerified': 'Nicht verifiziert',

  // Admin Coupons
  'admin.coupons.loadError': 'Fehler beim Laden der Gutscheine',
  'admin.coupons.fillRequired': 'Bitte füllen Sie alle Pflichtfelder aus',
  'admin.coupons.chooseExpiry': 'Bitte wählen Sie ein Ablaufdatum oder aktivieren Sie "Unbegrenzt gültig"',
  'admin.coupons.createError': 'Fehler beim Erstellen',
  'admin.coupons.confirmDelete': 'Möchten Sie diesen Gutschein wirklich löschen?',
  'admin.coupons.deleteError': 'Fehler beim Löschen',
  'admin.coupons.updateError': 'Fehler beim Aktualisieren',
  'admin.coupons.allPlans': 'Alle Pakete',
  'admin.coupons.percentDiscount': '{{pct}}% Rabatt',
  'admin.coupons.credits': 'Credits',
  'admin.coupons.days': 'Tage',
  'admin.coupons.months': 'Monate',
  'admin.coupons.free': 'gratis',
  'admin.coupons.title': 'Gutschein-Verwaltung',
  'admin.coupons.subtitle': 'Erstellen und verwalten Sie Gutschein-Codes',
  'admin.coupons.newCoupon': 'Neuer Gutschein',
  'admin.coupons.registrationTab': 'Registrierungs-Gutscheine',
  'admin.coupons.trialTab': 'Test-Zugangs-Gutscheine',
  'admin.coupons.typeRegistration': 'Registrierung',
  'admin.coupons.typeTrial': 'Test-Zugang',
  'admin.coupons.colStatus': 'Status',
  'admin.coupons.colCode': 'Code',
  'admin.coupons.colType': 'Typ',
  'admin.coupons.colPlan': 'Paket',
  'admin.coupons.colValue': 'Wert',
  'admin.coupons.colUsage': 'Verwendung',
  'admin.coupons.colValidUntil': 'Gültig bis',
  'admin.coupons.colActions': 'Aktionen',
  'admin.coupons.colCredits': 'Credits',
  'admin.coupons.colDuration': 'Dauer',
  'admin.coupons.copyCode': 'Code kopieren',
  'admin.coupons.unlimited': 'Unbegrenzt',
  'admin.coupons.noRegistrationCoupons': 'Noch keine Registrierungs-Gutscheine vorhanden.',
  'admin.coupons.noTrialCoupons': 'Noch keine Test-Zugangs-Gutscheine vorhanden.',
  'admin.coupons.createRegistrationTitle': 'Registrierungs-Gutschein erstellen',
  'admin.coupons.createTrialTitle': 'Test-Zugangs-Gutschein erstellen',
  'admin.coupons.labelCode': 'Gutschein-Code *',
  'admin.coupons.codePlaceholder': 'z.B. NF-7X3K9M',
  'admin.coupons.generateCode': 'Neuen Code generieren',
  'admin.coupons.labelType': 'Typ *',
  'admin.coupons.typeDiscount': 'Rabatt',
  'admin.coupons.typeCredits': 'Credits',
  'admin.coupons.typeUniversal': 'Universal',
  'admin.coupons.labelPlan': 'Paket',
  'admin.coupons.planAllUniversal': 'Alle Pakete (Universal)',
  'admin.coupons.planStarter': 'Nur Starter',
  'admin.coupons.planPro': 'Nur Pro',
  'admin.coupons.planBuilder': 'Nur Builder',
  'admin.coupons.labelDiscountPct': 'Rabatt % (optional)',
  'admin.coupons.discountPlaceholder': 'z.B. 50 für 50% Rabatt',
  'admin.coupons.labelBonusCredits': 'Bonus-Credits (optional)',
  'admin.coupons.bonusCreditsPlaceholder': 'z.B. 500',
  'admin.coupons.labelFreeDuration': 'Gratis-Dauer (optional)',
  'admin.coupons.durationPlaceholder': 'z.B. 30',
  'admin.coupons.unlimitedUses': 'Unbegrenzte Einlösungen',
  'admin.coupons.unlimitedUsesDesc': 'Keine Limitierung der Nutzungen',
  'admin.coupons.labelMaxUses': 'Maximale Einlösungen',
  'admin.coupons.labelMaxUsesRequired': 'Maximale Einlösungen *',
  'admin.coupons.noExpiry': 'Unbegrenzt gültig',
  'admin.coupons.noExpiryDesc': 'Kein Ablaufdatum',
  'admin.coupons.labelValidUntil': 'Gültig bis',
  'admin.coupons.labelCredits': 'Credits *',
  'admin.coupons.creditsPlaceholder': 'z.B. 100',
  'admin.coupons.labelTrialDuration': 'Test-Dauer *',
  'admin.coupons.trialDurationPlaceholder': 'z.B. 7',
  'admin.coupons.autoCalcExpiry': 'Wird automatisch aus der Test-Dauer berechnet',

  // Admin Downgrades
  'admin.downgrades.loadError': 'Fehler beim Laden',
  'admin.downgrades.confirmApprove': 'Downgrade-Anfrage von {{user}} genehmigen?',
  'admin.downgrades.confirmReject': 'Diese Downgrade-Anfrage wirklich ablehnen?',
  'admin.downgrades.approveError': 'Fehler beim Genehmigen',
  'admin.downgrades.rejectError': 'Fehler beim Ablehnen',
  'admin.downgrades.statusPending': 'Ausstehend',
  'admin.downgrades.statusApproved': 'Genehmigt',
  'admin.downgrades.statusRejected': 'Abgelehnt',
  'admin.downgrades.sectionRequests': 'Anfragen',
  'admin.downgrades.sectionStats': 'Statistiken',
  'admin.downgrades.sectionReports': 'Reports',
  'admin.downgrades.pendingRequests': 'Ausstehende Anfragen',
  'admin.downgrades.approvedRequests': 'Genehmigte Anfragen',
  'admin.downgrades.rejectedRequests': 'Abgelehnte Anfragen',
  'admin.downgrades.refundsApproved': 'Erstattungen (Genehmigt)',
  'admin.downgrades.noRequests': 'Keine Anfragen gefunden',
  'admin.downgrades.user': 'Benutzer',
  'admin.downgrades.refund': 'Rückerstattung',
  'admin.downgrades.approve': 'Genehmigen',
  'admin.downgrades.reject': 'Ablehnen',
  'admin.downgrades.range7d': '7 Tage',
  'admin.downgrades.range30d': '30 Tage',
  'admin.downgrades.range90d': '90 Tage',
  'admin.downgrades.range1y': '1 Jahr',
  'admin.downgrades.totalRequests': 'Gesamt-Anfragen',
  'admin.downgrades.approvalRate': 'Genehmigungsrate',
  'admin.downgrades.requestsPerMonth': 'Anfragen pro Monat',
  'admin.downgrades.monthApproved': '{{count}} genehmigt',
  'admin.downgrades.monthRejected': '{{count}} abgelehnt',
  'admin.downgrades.monthPending': '{{count}} ausstehend',
  'admin.downgrades.topReasons': 'Top Kündigungsgründe',
  'admin.downgrades.noReasons': 'Keine Gründe erfasst',
  'admin.downgrades.planTransitions': 'Paket-Wechsel',
  'admin.downgrades.noTransitions': 'Keine Übergänge',
  'admin.downgrades.exportReport': 'Report exportieren',
  'admin.downgrades.exportDescription': 'Exportieren Sie {{count}} Anfragen aus dem gewählten Zeitraum',
  'admin.downgrades.asCsv': 'Als CSV',
  'admin.downgrades.asJson': 'Als JSON',
  'admin.downgrades.export.id': 'ID',
  'admin.downgrades.export.userId': 'Benutzer-ID',
  'admin.downgrades.export.fromPlan': 'Von Paket',
  'admin.downgrades.export.toPlan': 'Zu Paket',
  'admin.downgrades.export.reason': 'Grund',
  'admin.downgrades.export.refund': 'Rückerstattung',
  'admin.downgrades.export.date': 'Datum',
  'admin.downgrades.export.status': 'Status',

  // Admin Downgrade Modal
  'admin.downgradeModal.title': 'Benutzer herabstufen',
  'admin.downgradeModal.createError': 'Fehler beim Erstellen',
  'admin.downgradeModal.requestCreated': 'Anfrage erstellt!',
  'admin.downgradeModal.requestCreatedDesc': 'Die Downgrade-Anfrage wurde erfolgreich erstellt und wartet auf Genehmigung.',
  'admin.downgradeModal.closing': 'Wird geschlossen...',
  'admin.downgradeModal.currentPlan': 'Aktuelles Paket',
  'admin.downgradeModal.creditsPerMonth': '{{credits}} Credits/Monat',
  'admin.downgradeModal.price': 'Preis',
  'admin.downgradeModal.availablePlans': 'Verfügbare Pakete für Downgrade',
  'admin.downgradeModal.noLowerPlans': 'Keine niedrigeren Pakete verfügbar.',
  'admin.downgradeModal.perMonth': 'pro Monat',
  'admin.downgradeModal.refundAmount': 'Rückerstattungs-Betrag (CHF)',
  'admin.downgradeModal.refundHint': 'Optional. Leer lassen oder 0 für keine Rückerstattung.',
  'admin.downgradeModal.reasonOptional': 'Grund (optional)',
  'admin.downgradeModal.infoNotice': 'Die Downgrade-Anfrage wird erstellt und muss noch genehmigt werden. Nach Genehmigung wird das Paket gewechselt und die Rückerstattung verarbeitet.',
  'admin.downgradeModal.creating': 'Wird erstellt...',
  'admin.downgradeModal.createRequest': 'Anfrage erstellen',

  // Admin Transactions
  'admin.transactions.loadError': 'Fehler beim Laden der Transaktionen',
  'admin.transactions.validAmountRequired': 'Bitte geben Sie einen gültigen Betrag ein',
  'admin.transactions.refundError': 'Fehler bei der Rückerstattung',
  'admin.transactions.typeUpgrade': 'Upgrade',
  'admin.transactions.typeDowngrade': 'Downgrade',
  'admin.transactions.typeSubscription': 'Abo',
  'admin.transactions.typeRefund': 'Rückerstattung',
  'admin.transactions.typeBonus': 'Bonus',
  'admin.transactions.allStatus': 'Alle Status',
  'admin.transactions.status_completed': 'Abgeschlossen',
  'admin.transactions.status_pending': 'Ausstehend',
  'admin.transactions.status_failed': 'Fehlgeschlagen',
  'admin.transactions.noTransactions': 'Keine Transaktionen gefunden',
  'admin.transactions.userId': 'Benutzer-ID',
  'admin.transactions.invoice': 'Rechnung',
  'admin.transactions.includingVat': 'inkl. CHF {{amount}} MwSt',
  'admin.transactions.refund': 'Rückerstattung',
  'admin.transactions.pageOf': 'Seite {{page}} von {{total}} ({{count}} Transaktionen)',
  'admin.transactions.issueRefund': 'Rückerstattung ausstellen',
  'admin.transactions.transaction': 'Transaktion',
  'admin.transactions.original': 'Original',
  'admin.transactions.amount': 'Betrag (CHF)',
  'admin.transactions.reasonOptional': 'Grund (optional)',
  'admin.transactions.refunding': 'Wird erstattet...',
  'admin.transactions.issueRefundBtn': 'Erstatten',

  // Admin Tips
  'admin.tips.loadError': 'Fehler beim Laden der Tipps',
  'admin.tips.createError': 'Fehler beim Erstellen',
  'admin.tips.updateError': 'Fehler beim Aktualisieren',
  'admin.tips.saveError': 'Fehler beim Speichern',
  'admin.tips.confirmDelete': 'Tipp wirklich löschen?',
  'admin.tips.deleteError': 'Fehler beim Löschen',
  'admin.tips.title': 'Tipp des Tages',
  'admin.tips.subtitle': 'Erstellen und verwalten Sie Tipps, die allen Benutzern angezeigt werden',
  'admin.tips.active': 'Aktiv',
  'admin.tips.activeNotice': 'Dieser Tipp wird aktuell allen Benutzern angezeigt',
  'admin.tips.createNew': 'Neuen Tipp erstellen',
  'admin.tips.generating': 'Generiere...',
  'admin.tips.sampleTip': 'Beispiel-Tipp',
  'admin.tips.category': 'Kategorie',
  'admin.tips.content': 'Inhalt',
  'admin.tips.contentPlaceholder': 'Schreiben Sie hier Ihren Tipp für die Benutzer...',
  'admin.tips.addTip': 'Tipp hinzufügen',
  'admin.tips.allTips': 'Alle Tipps ({{count}})',
  'admin.tips.noTips': 'Noch keine Tipps erstellt',
  'admin.tips.activate': 'Aktivieren',
  'admin.tips.deactivate': 'Deaktivieren',
  'admin.tips.categoryFeature': 'Neue Funktion',
  'admin.tips.categoryProductivity': 'Produktivität',
  'admin.tips.categoryUpdate': 'Update',
  'admin.tips.categoryTip': 'Tipp',

  // Admin Website Editor
  'admin.website.title': 'Website-Editor',
  'admin.website.subtitle': 'Startseite bearbeiten',
  'admin.website.preview': 'Vorschau',
  'admin.website.editTextsFor': 'Bearbeiten Sie Texte für:',
  'admin.website.changeLanguage': 'Sprache wechseln',
  'admin.website.groupStructure': 'Seitenstruktur',
  'admin.website.groupDesign': 'Design & Layout',
  'admin.website.groupSettings': 'Einstellungen',
  'admin.website.tabNavbar': 'Navigation',
  'admin.website.tabHero': 'Hero',
  'admin.website.tabFeatures': 'Features',
  'admin.website.tabHowItWorks': 'So funktioniert\u0027s',
  'admin.website.tabTestimonials': 'Testimonials',
  'admin.website.tabAbout': 'Über uns',
  'admin.website.tabPricing': 'Preise',
  'admin.website.tabFaq': 'FAQ',
  'admin.website.tabCta': 'CTA',
  'admin.website.tabFooter': 'Footer',
  'admin.website.tabDesign': 'Design',
  'admin.website.tabSections': 'Sektionen',
  'admin.website.tabMedia': 'Medien',
  'admin.website.tabCustomCode': 'Custom Code',
  'admin.website.tabChatWidget': 'Talk with Us',
  'admin.website.tabInvoice': 'Rechnungen',
  'admin.website.tabSocials': 'Social Media',
  'admin.website.tabLegal': 'Rechtliches',
  'admin.website.tabSeo': 'SEO Basis',
  'admin.website.tabAdvancedSeo': 'SEO Erweitert',
  'admin.website.tabVersions': 'Versionen',
  'admin.website.tabImportExport': 'Import/Export',

  // Admin AI Settings
  'admin.aiSettings.saveError': 'KI-Einstellungen konnten nicht gespeichert werden',
  'admin.aiSettings.title': 'KI-Assistent Einstellungen',
  'admin.aiSettings.subtitle': 'Verhalten, Stil und Analyse-Tiefe konfigurieren',
  'admin.aiSettings.modelRouting': 'Model-Routing',
  'admin.aiSettings.modelRoutingDesc': 'Wählen Sie das passende Modell pro Aufgabe. Nicht verfügbare Anbieter fallen automatisch auf OpenAI zurück.',
  'admin.aiSettings.enableWebSearch': 'Web-Suche aktivieren (Wettbewerb + Marktdaten)',
  'admin.aiSettings.ready': 'bereit',
  'admin.aiSettings.noKey': 'kein Schlüssel',
  'admin.aiSettings.tavilyReady': 'Tavily: bereit',
  'admin.aiSettings.taskReady': '✓ bereit',
  'admin.aiSettings.taskFallsBack': '⚠ Fallback',
  'admin.aiSettings.intelligentWeightingTitle': 'Intelligente Gewichtung aktiv',
  'admin.aiSettings.intelligentWeightingDesc': 'Die KI kombiniert automatisch alle Perspektiven mit intelligenter Gewichtung. Bei mehreren Vorlagen wird die erste stärker gewichtet (Primär-Vorlage). Sie können die Gewichtung auch manuell anpassen.',
  'admin.aiSettings.recommendationsTitle': '💡 Empfehlungen für optimale Ergebnisse',
  'admin.aiSettings.newBadge': 'NEU',
  'admin.aiSettings.recommendationsDesc': 'Bewährte Vorlagen-Kombinationen für beste Analyse-Qualität',
  'admin.aiSettings.recommendationsInfo': 'Diese Kombinationen wurden getestet und liefern die besten Ergebnisse. Klicken Sie auf eine Empfehlung, um sie direkt anzuwenden.',
  'admin.aiSettings.activeBadge': 'AKTIV',
  'admin.aiSettings.apply': 'Anwenden',
  'admin.aiSettings.avoid': 'Vermeiden',
  'admin.aiSettings.qualityExcellent': 'Exzellente Qualität',
  'admin.aiSettings.qualityGood': 'Gute Qualität',
  'admin.aiSettings.qualityPoor': 'Verwässerte Qualität — nicht empfohlen',
  'admin.aiSettings.proTips': 'Profi-Tipps',
  'admin.aiSettings.manyPresetsTitle': 'Achtung: Viele Vorlagen',
  'admin.aiSettings.manyPresetsDesc': 'Sie haben {{count}} Vorlagen ausgewählt. Das kann das Ergebnis verwässern. Empfohlen: Maximal 2-3 Vorlagen für optimale Ergebnisse.',
  'admin.aiSettings.presets': 'Vorlagen',
  'admin.aiSettings.multiSelect': '(Mehrfachauswahl möglich)',
  'admin.aiSettings.presetsDesc': 'Wählen Sie eine oder mehrere Vorlagen. Die erste Vorlage ist die Primär-Vorlage mit höchster Gewichtung.',
  'admin.aiSettings.primaryPreset': 'Primär-Vorlage',
  'admin.aiSettings.weightControl': 'Gewichtungs-Steuerung',
  'admin.aiSettings.weightControlDesc': 'Passen Sie an, wie stark jede Vorlage die Analyse beeinflusst',
  'admin.aiSettings.manual': 'Manuell',
  'admin.aiSettings.automatic': 'Automatisch',
  'admin.aiSettings.autoWeightingActive': 'Automatische Gewichtung aktiv: Die Gewichtung wird automatisch optimiert, basierend auf der Anzahl der Vorlagen.',
  'admin.aiSettings.primary': 'PRIMÄR',
  'admin.aiSettings.totalWeight': 'Gesamt: {{total}}% (sollte 100% sein)',
  'admin.aiSettings.normalize': 'Normalisieren',
  'admin.aiSettings.combinedSettings': 'Kombinierte Einstellungen ({{count}} Vorlagen)',
  'admin.aiSettings.strictness': 'Strenge',
  'admin.aiSettings.realism': 'Realismus',
  'admin.aiSettings.creativity': 'Kreativität',
  'admin.aiSettings.detailLevel': 'Detail-Tiefe',
  'admin.aiSettings.customInstructions': 'Benutzerdefinierte Anweisungen',
  'admin.aiSettings.customInstructionsDesc': 'Zusätzliche Anweisungen, die mit den Vorlagen kombiniert werden',
  'admin.aiSettings.customInstructionsPlaceholder': 'z.B. "Fokussieren Sie sich auf den DACH-Markt", "Verwenden Sie immer konkrete Zahlen", "Vergleichen Sie mit bestehenden Wettbewerbern"...',
  'admin.aiSettings.customInstructionsHint': 'Diese Anweisungen werden automatisch mit den ausgewählten Vorlagen kombiniert.',
  'admin.aiSettings.manualTuning': 'Manuelle Feinabstimmung',
  'admin.aiSettings.manualTuningHint': '(optional, überschreibt Vorlagen-Werte)',
  'admin.aiSettings.manualTuningDesc': 'Passen Sie die kombinierten Werte manuell an, wenn Sie etwas feinjustieren möchten.',
  'admin.aiSettings.tone': 'Tonalität',
  'admin.aiSettings.toneLabel': 'Ton',
  'admin.aiSettings.lengthLabel': 'Länge',
  'admin.aiSettings.presetsLabel': 'Vorlagen',
  'admin.aiSettings.mild': 'Mild',
  'admin.aiSettings.strict': 'Streng',
  'admin.aiSettings.creative': 'Kreativ',
  'admin.aiSettings.realistic': 'Realistisch',
  'admin.aiSettings.conservative': 'Konservativ',
  'admin.aiSettings.compact': 'Kompakt',
  'admin.aiSettings.detailed': 'Detailliert',
  'admin.aiSettings.responseLength': 'Antwortlänge',
  'admin.aiSettings.lengthShort': 'Kurz & Knapp',
  'admin.aiSettings.lengthMedium': 'Mittel',
  'admin.aiSettings.lengthLong': 'Ausführlich',
  'admin.aiSettings.focusAreas': 'Analyse-Schwerpunkte',
  'admin.aiSettings.autoRating': 'Automatische Bewertung',
  'admin.aiSettings.autoRatingDesc': 'Jede Analyse erhält automatisch eine Bewertung (Gut/Mittel/Schlecht)',
  'admin.aiSettings.showSources': 'Quellen anzeigen',
  'admin.aiSettings.showSourcesDesc': 'Verweise auf Datenquellen und Marktdaten in Antworten',
  'admin.aiSettings.hidePreview': 'Vorschau ausblenden',
  'admin.aiSettings.showPreview': 'Vorschau anzeigen',
  'admin.aiSettings.aiBehavior': 'KI-Verhalten',
  'admin.aiSettings.liveExample': 'Live-Beispiel',
  'admin.aiSettings.testSettings': 'Testen Sie Ihre Einstellungen',
  'admin.aiSettings.pickSampleQuestion': 'Beispiel-Frage auswählen:',
  'admin.aiSettings.userAsks': 'Benutzer fragt:',
  'admin.aiSettings.generatingAnswer': 'KI generiert Antwort...',
  'admin.aiSettings.generateSample': 'Beispiel-Antwort generieren',
  'admin.aiSettings.aiAnswers': 'KI-Assistent antwortet:',
  'admin.aiSettings.generateHint': 'Klicken Sie auf "Beispiel-Antwort generieren", um zu sehen, wie die KI mit Ihren Einstellungen antwortet.',
  'admin.aiSettings.reset': 'Zurücksetzen',
  'admin.aiSettings.saved': 'Gespeichert!',
  'admin.aiSettings.saveSettings': 'Einstellungen speichern',
  'admin.aiSettings.toneDirect': 'Direkt & Unverblümt',
  'admin.aiSettings.toneProfessional': 'Professionell & Sachlich',
  'admin.aiSettings.toneHonest': 'Ehrlich & Praxisnah',
  'admin.aiSettings.toneMotivating': 'Motivierend & Positiv',
  'admin.aiSettings.toneFriendly': 'Freundlich & Unterstützend',
  'admin.aiSettings.toneAcademic': 'Akademisch & Analytisch',
  'admin.aiSettings.focus.marketAnalysis': 'Marktanalyse',
  'admin.aiSettings.focus.competition': 'Wettbewerb',
  'admin.aiSettings.focus.monetization': 'Monetarisierung',
  'admin.aiSettings.focus.risks': 'Risiken',
  'admin.aiSettings.focus.finance': 'Finanzen',
  'admin.aiSettings.focus.scaling': 'Skalierung',
  'admin.aiSettings.focus.innovation': 'Innovation',
  'admin.aiSettings.focus.trends': 'Trends',
  'admin.aiSettings.focus.differentiation': 'Differenzierung',
  'admin.aiSettings.focus.execution': 'Umsetzung',
  'admin.aiSettings.focus.audience': 'Zielgruppe',
  'admin.aiSettings.focus.marketing': 'Marketing',
  'admin.aiSettings.sample.niche': 'Welche profitable Nische empfehlen Sie mir?',
  'admin.aiSettings.sample.evaluate': 'Bewerten Sie meine Idee: Eine App für Hundebesitzer',
  'admin.aiSettings.sample.trends': 'Welche Trends haben aktuell Potenzial?',
  'admin.aiSettings.sample.sharpen': 'Wie kann ich meine Nische schärfen?',
  'footer.disclaimer': 'Haftungsausschluss',
  'legal.backToHome': 'Zurück zur Startseite',
  'legal.lastUpdated': 'Zuletzt aktualisiert',
  'legal.authoritativeNotice': 'Eine lokalisierte Fassung in Ihrer Sprache ist noch nicht verfügbar. Nachfolgend finden Sie die englische, rechtlich verbindliche Originalfassung.',
  'legal.translationNotice': 'Dies ist eine Komfortübersetzung. Die englische Fassung ist die rechtlich verbindliche Originalversion.',
};

export default common;
